export const hate_data = {
  15: {
    Alabama: null,
    Alaska: null,
    Arizona: null,
    Arkansas: null,
    California: 1.0,
    Colorado: null,
    Connecticut: null,
    "D.C.": null,
    Delaware: null,
    Florida: null,
    Georgia: null,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: null,
    Indiana: null,
    Iowa: null,
    Kansas: null,
    Kentucky: null,
    Louisiana: null,
    Maine: null,
    Maryland: null,
    Massachusetts: null,
    Michigan: null,
    Minnesota: null,
    Mississippi: null,
    Missouri: null,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": null,
    "New York": null,
    None: null,
    "North Carolina": null,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: null,
    Oklahoma: null,
    Oregon: null,
    Pennsylvania: null,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: null,
    Texas: null,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: null,
    Washington: null,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  16: {
    Alabama: null,
    Alaska: null,
    Arizona: null,
    Arkansas: null,
    California: null,
    Colorado: null,
    Connecticut: null,
    "D.C.": null,
    Delaware: null,
    Florida: null,
    Georgia: null,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: null,
    Indiana: null,
    Iowa: null,
    Kansas: null,
    Kentucky: null,
    Louisiana: null,
    Maine: null,
    Maryland: null,
    Massachusetts: null,
    Michigan: null,
    Minnesota: null,
    Mississippi: null,
    Missouri: null,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": null,
    "New York": null,
    None: null,
    "North Carolina": null,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: null,
    Oklahoma: null,
    Oregon: null,
    Pennsylvania: 1.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: null,
    Texas: null,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: null,
    Washington: null,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  17: {
    Alabama: null,
    Alaska: null,
    Arizona: null,
    Arkansas: null,
    California: null,
    Colorado: null,
    Connecticut: null,
    "D.C.": null,
    Delaware: null,
    Florida: null,
    Georgia: null,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: null,
    Indiana: null,
    Iowa: null,
    Kansas: null,
    Kentucky: null,
    Louisiana: null,
    Maine: null,
    Maryland: null,
    Massachusetts: null,
    Michigan: null,
    Minnesota: null,
    Mississippi: null,
    Missouri: null,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": null,
    "New York": null,
    None: null,
    "North Carolina": 1.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: null,
    Oklahoma: null,
    Oregon: null,
    Pennsylvania: null,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: null,
    Texas: null,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: null,
    Washington: null,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  20: {
    Alabama: null,
    Alaska: null,
    Arizona: null,
    Arkansas: null,
    California: 1.0,
    Colorado: null,
    Connecticut: null,
    "D.C.": null,
    Delaware: null,
    Florida: null,
    Georgia: null,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: null,
    Indiana: null,
    Iowa: null,
    Kansas: null,
    Kentucky: null,
    Louisiana: null,
    Maine: null,
    Maryland: null,
    Massachusetts: null,
    Michigan: null,
    Minnesota: null,
    Mississippi: null,
    Missouri: null,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": null,
    "New York": null,
    None: 1.0,
    "North Carolina": null,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: null,
    Oklahoma: null,
    Oregon: null,
    Pennsylvania: null,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: null,
    Texas: null,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: null,
    Washington: null,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  21: {
    Alabama: null,
    Alaska: null,
    Arizona: null,
    Arkansas: null,
    California: 2.0,
    Colorado: null,
    Connecticut: null,
    "D.C.": null,
    Delaware: null,
    Florida: null,
    Georgia: null,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 1.0,
    Indiana: null,
    Iowa: null,
    Kansas: null,
    Kentucky: null,
    Louisiana: null,
    Maine: null,
    Maryland: 1.0,
    Massachusetts: null,
    Michigan: null,
    Minnesota: null,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": null,
    "New York": null,
    None: null,
    "North Carolina": null,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: null,
    Oklahoma: null,
    Oregon: null,
    Pennsylvania: null,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: 1.0,
    Texas: null,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: null,
    Washington: 1.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  22: {
    Alabama: null,
    Alaska: null,
    Arizona: null,
    Arkansas: null,
    California: null,
    Colorado: null,
    Connecticut: null,
    "D.C.": null,
    Delaware: null,
    Florida: 1.0,
    Georgia: null,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: null,
    Indiana: null,
    Iowa: null,
    Kansas: null,
    Kentucky: null,
    Louisiana: null,
    Maine: null,
    Maryland: null,
    Massachusetts: null,
    Michigan: null,
    Minnesota: null,
    Mississippi: null,
    Missouri: null,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": null,
    "New York": 1.0,
    None: null,
    "North Carolina": null,
    "North Dakota": 1.0,
    "Northern Mariana Islands": null,
    Ohio: null,
    Oklahoma: null,
    Oregon: null,
    Pennsylvania: null,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: null,
    Texas: 1.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 1.0,
    Washington: null,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  23: {
    Alabama: null,
    Alaska: null,
    Arizona: 1.0,
    Arkansas: null,
    California: 9.0,
    Colorado: null,
    Connecticut: null,
    "D.C.": 1.0,
    Delaware: null,
    Florida: 2.0,
    Georgia: null,
    Guam: null,
    Hawaii: 1.0,
    Idaho: null,
    Illinois: 1.0,
    Indiana: null,
    Iowa: null,
    Kansas: 1.0,
    Kentucky: null,
    Louisiana: null,
    Maine: null,
    Maryland: 1.0,
    Massachusetts: 2.0,
    Michigan: null,
    Minnesota: null,
    Mississippi: null,
    Missouri: null,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": 1.0,
    "New York": 4.0,
    None: 6.0,
    "North Carolina": null,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: null,
    Oregon: 1.0,
    Pennsylvania: 2.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: null,
    Texas: 1.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: null,
    Washington: 2.0,
    "West Virginia": 1.0,
    Wisconsin: null,
    Wyoming: null,
  },
  24: {
    Alabama: 2.0,
    Alaska: null,
    Arizona: null,
    Arkansas: null,
    California: 15.0,
    Colorado: 4.0,
    Connecticut: 1.0,
    "D.C.": 3.0,
    Delaware: null,
    Florida: 1.0,
    Georgia: 4.0,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: null,
    Indiana: null,
    Iowa: null,
    Kansas: 1.0,
    Kentucky: null,
    Louisiana: null,
    Maine: null,
    Maryland: 2.0,
    Massachusetts: null,
    Michigan: null,
    Minnesota: null,
    Mississippi: null,
    Missouri: 1.0,
    Montana: 1.0,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": 2.0,
    "New Mexico": 1.0,
    "New York": 4.0,
    None: 13.0,
    "North Carolina": 1.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 3.0,
    Oklahoma: null,
    Oregon: 1.0,
    Pennsylvania: null,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": 1.0,
    Tennessee: null,
    Texas: 8.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 2.0,
    Washington: 1.0,
    "West Virginia": 1.0,
    Wisconsin: null,
    Wyoming: null,
  },
  25: {
    Alabama: 1.0,
    Alaska: null,
    Arizona: null,
    Arkansas: null,
    California: 8.0,
    Colorado: 1.0,
    Connecticut: null,
    "D.C.": 5.0,
    Delaware: 1.0,
    Florida: 3.0,
    Georgia: 2.0,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 2.0,
    Indiana: 1.0,
    Iowa: 1.0,
    Kansas: 2.0,
    Kentucky: null,
    Louisiana: null,
    Maine: 2.0,
    Maryland: 2.0,
    Massachusetts: 5.0,
    Michigan: null,
    Minnesota: null,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: null,
    Nevada: 2.0,
    "New Hampshire": null,
    "New Jersey": 2.0,
    "New Mexico": null,
    "New York": 8.0,
    None: 7.0,
    "North Carolina": 1.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: null,
    Oklahoma: 1.0,
    Oregon: 2.0,
    Pennsylvania: 1.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: 1.0,
    Texas: 5.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 2.0,
    Washington: null,
    "West Virginia": 1.0,
    Wisconsin: null,
    Wyoming: null,
  },
  26: {
    Alabama: null,
    Alaska: null,
    Arizona: 3.0,
    Arkansas: null,
    California: 12.0,
    Colorado: 1.0,
    Connecticut: null,
    "D.C.": 2.0,
    Delaware: null,
    Florida: 1.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: null,
    Illinois: null,
    Indiana: null,
    Iowa: null,
    Kansas: null,
    Kentucky: null,
    Louisiana: 1.0,
    Maine: null,
    Maryland: null,
    Massachusetts: 1.0,
    Michigan: 1.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: null,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": null,
    "New York": 6.0,
    None: 13.0,
    "North Carolina": null,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 4.0,
    Oklahoma: null,
    Oregon: null,
    Pennsylvania: 3.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 2.0,
    "South Dakota": null,
    Tennessee: null,
    Texas: 4.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 4.0,
    Washington: null,
    "West Virginia": null,
    Wisconsin: 2.0,
    Wyoming: null,
  },
  27: {
    Alabama: null,
    Alaska: null,
    Arizona: null,
    Arkansas: null,
    California: 4.0,
    Colorado: 1.0,
    Connecticut: null,
    "D.C.": 1.0,
    Delaware: null,
    Florida: 1.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 1.0,
    Indiana: 1.0,
    Iowa: null,
    Kansas: null,
    Kentucky: null,
    Louisiana: null,
    Maine: null,
    Maryland: null,
    Massachusetts: null,
    Michigan: 1.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: 1.0,
    Montana: 1.0,
    Nebraska: null,
    Nevada: 1.0,
    "New Hampshire": null,
    "New Jersey": 2.0,
    "New Mexico": null,
    "New York": 6.0,
    None: 10.0,
    "North Carolina": 2.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: null,
    Oklahoma: null,
    Oregon: 1.0,
    Pennsylvania: 1.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: null,
    Texas: 7.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: 1.0,
    Virginia: 1.0,
    Washington: 1.0,
    "West Virginia": null,
    Wisconsin: 1.0,
    Wyoming: null,
  },
  28: {
    Alabama: null,
    Alaska: null,
    Arizona: 1.0,
    Arkansas: null,
    California: 12.0,
    Colorado: null,
    Connecticut: 1.0,
    "D.C.": 4.0,
    Delaware: null,
    Florida: null,
    Georgia: 2.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: null,
    Illinois: 1.0,
    Indiana: 1.0,
    Iowa: 1.0,
    Kansas: null,
    Kentucky: 1.0,
    Louisiana: 1.0,
    Maine: null,
    Maryland: 2.0,
    Massachusetts: 1.0,
    Michigan: 1.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: 2.0,
    Nevada: 1.0,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": null,
    "New York": 10.0,
    None: 7.0,
    "North Carolina": 1.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: null,
    Oklahoma: null,
    Oregon: 1.0,
    Pennsylvania: 1.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 1.0,
    "South Dakota": null,
    Tennessee: 1.0,
    Texas: 2.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: 4.0,
    Washington: 2.0,
    "West Virginia": null,
    Wisconsin: 1.0,
    Wyoming: 1.0,
  },
  29: {
    Alabama: 2.0,
    Alaska: null,
    Arizona: 4.0,
    Arkansas: 1.0,
    California: 20.0,
    Colorado: 4.0,
    Connecticut: 1.0,
    "D.C.": 4.0,
    Delaware: 3.0,
    Florida: 7.0,
    Georgia: 3.0,
    Guam: null,
    Hawaii: 4.0,
    Idaho: null,
    Illinois: 2.0,
    Indiana: 2.0,
    Iowa: 1.0,
    Kansas: 1.0,
    Kentucky: 2.0,
    Louisiana: 1.0,
    Maine: null,
    Maryland: 6.0,
    Massachusetts: 1.0,
    Michigan: 4.0,
    Minnesota: null,
    Mississippi: 1.0,
    Missouri: 3.0,
    Montana: null,
    Nebraska: 2.0,
    Nevada: 3.0,
    "New Hampshire": null,
    "New Jersey": 3.0,
    "New Mexico": 2.0,
    "New York": 19.0,
    None: 19.0,
    "North Carolina": 2.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 4.0,
    Oklahoma: 1.0,
    Oregon: 2.0,
    Pennsylvania: 4.0,
    "Puerto Rico": null,
    "Rhode Island": 1.0,
    "South Carolina": 1.0,
    "South Dakota": null,
    Tennessee: 1.0,
    Texas: 7.0,
    "United States Virgin Islands": null,
    Utah: 2.0,
    Vermont: null,
    Virginia: 2.0,
    Washington: 2.0,
    "West Virginia": 1.0,
    Wisconsin: null,
    Wyoming: 1.0,
  },
  30: {
    Alabama: 1.0,
    Alaska: null,
    Arizona: 2.0,
    Arkansas: null,
    California: 22.0,
    Colorado: 1.0,
    Connecticut: null,
    "D.C.": 2.0,
    Delaware: null,
    Florida: 3.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: null,
    Idaho: 1.0,
    Illinois: 2.0,
    Indiana: 1.0,
    Iowa: null,
    Kansas: 3.0,
    Kentucky: 2.0,
    Louisiana: 2.0,
    Maine: null,
    Maryland: 3.0,
    Massachusetts: null,
    Michigan: 1.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: 2.0,
    Montana: null,
    Nebraska: 1.0,
    Nevada: 2.0,
    "New Hampshire": null,
    "New Jersey": 2.0,
    "New Mexico": 1.0,
    "New York": 16.0,
    None: 18.0,
    "North Carolina": 2.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 8.0,
    Oklahoma: 1.0,
    Oregon: 2.0,
    Pennsylvania: 8.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 3.0,
    "South Dakota": null,
    Tennessee: 2.0,
    Texas: 20.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: 1.0,
    Virginia: 4.0,
    Washington: 2.0,
    "West Virginia": 1.0,
    Wisconsin: null,
    Wyoming: null,
  },
  31: {
    Alabama: null,
    Alaska: 1.0,
    Arizona: 4.0,
    Arkansas: null,
    California: 22.0,
    Colorado: 2.0,
    Connecticut: 2.0,
    "D.C.": 1.0,
    Delaware: null,
    Florida: 4.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: null,
    Illinois: 4.0,
    Indiana: 2.0,
    Iowa: null,
    Kansas: null,
    Kentucky: 2.0,
    Louisiana: 1.0,
    Maine: 2.0,
    Maryland: null,
    Massachusetts: 2.0,
    Michigan: 5.0,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": 2.0,
    "New Mexico": 3.0,
    "New York": 15.0,
    None: 24.0,
    "North Carolina": 3.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 4.0,
    Oklahoma: 1.0,
    Oregon: 3.0,
    Pennsylvania: 3.0,
    "Puerto Rico": null,
    "Rhode Island": 1.0,
    "South Carolina": 3.0,
    "South Dakota": 1.0,
    Tennessee: null,
    Texas: 14.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: 1.0,
    Virginia: 2.0,
    Washington: 1.0,
    "West Virginia": null,
    Wisconsin: 4.0,
    Wyoming: 1.0,
  },
  32: {
    Alabama: 2.0,
    Alaska: null,
    Arizona: null,
    Arkansas: null,
    California: 12.0,
    Colorado: null,
    Connecticut: null,
    "D.C.": 1.0,
    Delaware: null,
    Florida: 2.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 3.0,
    Indiana: null,
    Iowa: 2.0,
    Kansas: null,
    Kentucky: 2.0,
    Louisiana: 1.0,
    Maine: 1.0,
    Maryland: null,
    Massachusetts: 1.0,
    Michigan: 1.0,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: null,
    Nevada: 1.0,
    "New Hampshire": null,
    "New Jersey": 1.0,
    "New Mexico": null,
    "New York": null,
    None: 9.0,
    "North Carolina": 3.0,
    "North Dakota": 1.0,
    "Northern Mariana Islands": null,
    Ohio: null,
    Oklahoma: 2.0,
    Oregon: null,
    Pennsylvania: 3.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: null,
    Texas: 5.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 1.0,
    Washington: null,
    "West Virginia": null,
    Wisconsin: 1.0,
    Wyoming: 1.0,
  },
  33: {
    Alabama: null,
    Alaska: null,
    Arizona: 2.0,
    Arkansas: null,
    California: 9.0,
    Colorado: 1.0,
    Connecticut: null,
    "D.C.": null,
    Delaware: null,
    Florida: 8.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 4.0,
    Indiana: 1.0,
    Iowa: 1.0,
    Kansas: null,
    Kentucky: 1.0,
    Louisiana: null,
    Maine: null,
    Maryland: null,
    Massachusetts: null,
    Michigan: null,
    Minnesota: null,
    Mississippi: 1.0,
    Missouri: null,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": 1.0,
    "New Mexico": null,
    "New York": 4.0,
    None: 11.0,
    "North Carolina": 1.0,
    "North Dakota": 1.0,
    "Northern Mariana Islands": null,
    Ohio: null,
    Oklahoma: null,
    Oregon: null,
    Pennsylvania: null,
    "Puerto Rico": 1.0,
    "Rhode Island": 1.0,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: 1.0,
    Texas: 2.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 1.0,
    Washington: 1.0,
    "West Virginia": 1.0,
    Wisconsin: null,
    Wyoming: null,
  },
  34: {
    Alabama: null,
    Alaska: null,
    Arizona: 1.0,
    Arkansas: null,
    California: 6.0,
    Colorado: 2.0,
    Connecticut: 2.0,
    "D.C.": 2.0,
    Delaware: null,
    Florida: 2.0,
    Georgia: null,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 3.0,
    Indiana: null,
    Iowa: null,
    Kansas: 1.0,
    Kentucky: 1.0,
    Louisiana: 1.0,
    Maine: null,
    Maryland: 1.0,
    Massachusetts: 2.0,
    Michigan: 1.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: null,
    Montana: 1.0,
    Nebraska: null,
    Nevada: 1.0,
    "New Hampshire": null,
    "New Jersey": 1.0,
    "New Mexico": null,
    "New York": 4.0,
    None: 12.0,
    "North Carolina": 3.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: null,
    Oregon: null,
    Pennsylvania: 2.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: null,
    Texas: 5.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 1.0,
    Washington: 1.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: 1.0,
  },
  35: {
    Alabama: null,
    Alaska: null,
    Arizona: null,
    Arkansas: null,
    California: 13.0,
    Colorado: null,
    Connecticut: null,
    "D.C.": 2.0,
    Delaware: 1.0,
    Florida: 4.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 3.0,
    Indiana: null,
    Iowa: 2.0,
    Kansas: 1.0,
    Kentucky: null,
    Louisiana: 1.0,
    Maine: 1.0,
    Maryland: 1.0,
    Massachusetts: 3.0,
    Michigan: 3.0,
    Minnesota: 2.0,
    Mississippi: null,
    Missouri: 1.0,
    Montana: 1.0,
    Nebraska: 2.0,
    Nevada: null,
    "New Hampshire": 1.0,
    "New Jersey": 1.0,
    "New Mexico": null,
    "New York": 7.0,
    None: 9.0,
    "North Carolina": null,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 1.0,
    Oklahoma: null,
    Oregon: 3.0,
    Pennsylvania: 1.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: 2.0,
    Texas: 13.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 1.0,
    Washington: null,
    "West Virginia": null,
    Wisconsin: 1.0,
    Wyoming: 1.0,
  },
  36: {
    Alabama: 1.0,
    Alaska: null,
    Arizona: 3.0,
    Arkansas: null,
    California: 7.0,
    Colorado: 2.0,
    Connecticut: null,
    "D.C.": 2.0,
    Delaware: null,
    Florida: 1.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 2.0,
    Indiana: null,
    Iowa: null,
    Kansas: 1.0,
    Kentucky: null,
    Louisiana: null,
    Maine: null,
    Maryland: 4.0,
    Massachusetts: 1.0,
    Michigan: null,
    Minnesota: null,
    Mississippi: null,
    Missouri: null,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": null,
    "New York": 12.0,
    None: 7.0,
    "North Carolina": 1.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: null,
    Oregon: 1.0,
    Pennsylvania: 2.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: null,
    Texas: 9.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: null,
    Washington: 2.0,
    "West Virginia": null,
    Wisconsin: 2.0,
    Wyoming: 1.0,
  },
  37: {
    Alabama: null,
    Alaska: null,
    Arizona: null,
    Arkansas: null,
    California: 11.0,
    Colorado: 3.0,
    Connecticut: null,
    "D.C.": 2.0,
    Delaware: null,
    Florida: 5.0,
    Georgia: null,
    Guam: null,
    Hawaii: 1.0,
    Idaho: 1.0,
    Illinois: 1.0,
    Indiana: 1.0,
    Iowa: null,
    Kansas: 1.0,
    Kentucky: null,
    Louisiana: 2.0,
    Maine: null,
    Maryland: 3.0,
    Massachusetts: 1.0,
    Michigan: 3.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: 2.0,
    Montana: null,
    Nebraska: 1.0,
    Nevada: 2.0,
    "New Hampshire": null,
    "New Jersey": 1.0,
    "New Mexico": null,
    "New York": 10.0,
    None: 12.0,
    "North Carolina": 2.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: null,
    Oklahoma: null,
    Oregon: 2.0,
    Pennsylvania: 4.0,
    "Puerto Rico": null,
    "Rhode Island": 1.0,
    "South Carolina": 2.0,
    "South Dakota": null,
    Tennessee: 1.0,
    Texas: 7.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 1.0,
    Washington: 5.0,
    "West Virginia": null,
    Wisconsin: 1.0,
    Wyoming: null,
  },
  38: {
    Alabama: null,
    Alaska: 1.0,
    Arizona: 4.0,
    Arkansas: 2.0,
    California: 18.0,
    Colorado: 2.0,
    Connecticut: null,
    "D.C.": 3.0,
    Delaware: null,
    Florida: 3.0,
    Georgia: 3.0,
    Guam: 1.0,
    Hawaii: 1.0,
    Idaho: null,
    Illinois: 1.0,
    Indiana: 1.0,
    Iowa: 1.0,
    Kansas: null,
    Kentucky: null,
    Louisiana: 1.0,
    Maine: null,
    Maryland: null,
    Massachusetts: 2.0,
    Michigan: null,
    Minnesota: null,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: 1.0,
    Nevada: 1.0,
    "New Hampshire": 1.0,
    "New Jersey": 1.0,
    "New Mexico": 2.0,
    "New York": 6.0,
    None: 15.0,
    "North Carolina": 5.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 3.0,
    Oklahoma: null,
    Oregon: 1.0,
    Pennsylvania: 2.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 1.0,
    "South Dakota": null,
    Tennessee: 2.0,
    Texas: 5.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 2.0,
    Washington: 5.0,
    "West Virginia": null,
    Wisconsin: 1.0,
    Wyoming: null,
  },
  39: {
    Alabama: 1.0,
    Alaska: null,
    Arizona: 4.0,
    Arkansas: 2.0,
    California: 14.0,
    Colorado: 2.0,
    Connecticut: 1.0,
    "D.C.": 1.0,
    Delaware: null,
    Florida: 8.0,
    Georgia: 2.0,
    Guam: null,
    Hawaii: null,
    Idaho: 1.0,
    Illinois: 2.0,
    Indiana: null,
    Iowa: 1.0,
    Kansas: null,
    Kentucky: 1.0,
    Louisiana: null,
    Maine: null,
    Maryland: 1.0,
    Massachusetts: 1.0,
    Michigan: 1.0,
    Minnesota: null,
    Mississippi: 1.0,
    Missouri: 1.0,
    Montana: null,
    Nebraska: null,
    Nevada: 2.0,
    "New Hampshire": 1.0,
    "New Jersey": null,
    "New Mexico": 2.0,
    "New York": 12.0,
    None: 11.0,
    "North Carolina": 1.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: null,
    Oklahoma: 1.0,
    Oregon: 2.0,
    Pennsylvania: 4.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 1.0,
    "South Dakota": null,
    Tennessee: null,
    Texas: 8.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: 2.0,
    Washington: 2.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: 1.0,
  },
  40: {
    Alabama: null,
    Alaska: null,
    Arizona: 3.0,
    Arkansas: null,
    California: 14.0,
    Colorado: 1.0,
    Connecticut: null,
    "D.C.": 2.0,
    Delaware: null,
    Florida: 3.0,
    Georgia: 2.0,
    Guam: null,
    Hawaii: null,
    Idaho: 1.0,
    Illinois: 3.0,
    Indiana: null,
    Iowa: 1.0,
    Kansas: null,
    Kentucky: null,
    Louisiana: null,
    Maine: null,
    Maryland: 2.0,
    Massachusetts: 1.0,
    Michigan: null,
    Minnesota: null,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: 1.0,
    Nevada: 2.0,
    "New Hampshire": null,
    "New Jersey": 1.0,
    "New Mexico": 1.0,
    "New York": 6.0,
    None: 18.0,
    "North Carolina": 3.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: 1.0,
    Oregon: 1.0,
    Pennsylvania: null,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 2.0,
    "South Dakota": null,
    Tennessee: 3.0,
    Texas: 8.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: 1.0,
    Washington: 2.0,
    "West Virginia": null,
    Wisconsin: 2.0,
    Wyoming: null,
  },
  41: {
    Alabama: null,
    Alaska: null,
    Arizona: 1.0,
    Arkansas: null,
    California: 9.0,
    Colorado: null,
    Connecticut: null,
    "D.C.": 3.0,
    Delaware: 1.0,
    Florida: 5.0,
    Georgia: 4.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: null,
    Illinois: 2.0,
    Indiana: null,
    Iowa: 2.0,
    Kansas: 1.0,
    Kentucky: null,
    Louisiana: null,
    Maine: null,
    Maryland: 1.0,
    Massachusetts: 4.0,
    Michigan: 2.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: null,
    Montana: null,
    Nebraska: 2.0,
    Nevada: 1.0,
    "New Hampshire": 2.0,
    "New Jersey": 3.0,
    "New Mexico": 1.0,
    "New York": 8.0,
    None: 28.0,
    "North Carolina": 1.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: null,
    Oregon: null,
    Pennsylvania: 5.0,
    "Puerto Rico": 1.0,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: 2.0,
    Texas: 16.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: 1.0,
    Virginia: 1.0,
    Washington: 1.0,
    "West Virginia": null,
    Wisconsin: 2.0,
    Wyoming: null,
  },
  42: {
    Alabama: 1.0,
    Alaska: null,
    Arizona: 3.0,
    Arkansas: 1.0,
    California: 18.0,
    Colorado: 3.0,
    Connecticut: null,
    "D.C.": 1.0,
    Delaware: null,
    Florida: 5.0,
    Georgia: null,
    Guam: null,
    Hawaii: 2.0,
    Idaho: null,
    Illinois: 2.0,
    Indiana: null,
    Iowa: null,
    Kansas: null,
    Kentucky: 2.0,
    Louisiana: 1.0,
    Maine: 1.0,
    Maryland: null,
    Massachusetts: 2.0,
    Michigan: 3.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: 2.0,
    Montana: null,
    Nebraska: null,
    Nevada: 2.0,
    "New Hampshire": null,
    "New Jersey": 5.0,
    "New Mexico": null,
    "New York": 10.0,
    None: 27.0,
    "North Carolina": 2.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: null,
    Oregon: null,
    Pennsylvania: 3.0,
    "Puerto Rico": 1.0,
    "Rhode Island": null,
    "South Carolina": 1.0,
    "South Dakota": null,
    Tennessee: 4.0,
    Texas: 10.0,
    "United States Virgin Islands": null,
    Utah: 2.0,
    Vermont: null,
    Virginia: 6.0,
    Washington: 2.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  43: {
    Alabama: 1.0,
    Alaska: null,
    Arizona: null,
    Arkansas: 1.0,
    California: 14.0,
    Colorado: 2.0,
    Connecticut: null,
    "D.C.": 5.0,
    Delaware: null,
    Florida: 6.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: null,
    Illinois: 3.0,
    Indiana: 2.0,
    Iowa: 1.0,
    Kansas: 5.0,
    Kentucky: 4.0,
    Louisiana: null,
    Maine: 1.0,
    Maryland: null,
    Massachusetts: null,
    Michigan: null,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: 1.0,
    Montana: 1.0,
    Nebraska: null,
    Nevada: 1.0,
    "New Hampshire": 1.0,
    "New Jersey": 1.0,
    "New Mexico": 1.0,
    "New York": 10.0,
    None: 17.0,
    "North Carolina": 1.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: 1.0,
    Oregon: 1.0,
    Pennsylvania: 8.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 1.0,
    "South Dakota": null,
    Tennessee: null,
    Texas: 8.0,
    "United States Virgin Islands": null,
    Utah: 2.0,
    Vermont: null,
    Virginia: 2.0,
    Washington: 1.0,
    "West Virginia": null,
    Wisconsin: 2.0,
    Wyoming: null,
  },
  44: {
    Alabama: null,
    Alaska: null,
    Arizona: 2.0,
    Arkansas: null,
    California: 16.0,
    Colorado: 1.0,
    Connecticut: null,
    "D.C.": null,
    Delaware: null,
    Florida: 7.0,
    Georgia: 3.0,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 2.0,
    Indiana: 1.0,
    Iowa: 1.0,
    Kansas: null,
    Kentucky: 1.0,
    Louisiana: null,
    Maine: null,
    Maryland: 2.0,
    Massachusetts: 1.0,
    Michigan: 1.0,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: null,
    Montana: null,
    Nebraska: 1.0,
    Nevada: 1.0,
    "New Hampshire": null,
    "New Jersey": 1.0,
    "New Mexico": 1.0,
    "New York": 12.0,
    None: 19.0,
    "North Carolina": 3.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 3.0,
    Oklahoma: 1.0,
    Oregon: 1.0,
    Pennsylvania: 5.0,
    "Puerto Rico": 1.0,
    "Rhode Island": null,
    "South Carolina": 1.0,
    "South Dakota": null,
    Tennessee: 1.0,
    Texas: 11.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 1.0,
    Washington: 1.0,
    "West Virginia": 1.0,
    Wisconsin: 1.0,
    Wyoming: 1.0,
  },
  45: {
    Alabama: null,
    Alaska: 1.0,
    Arizona: 1.0,
    Arkansas: null,
    California: 10.0,
    Colorado: 2.0,
    Connecticut: 2.0,
    "D.C.": 1.0,
    Delaware: null,
    Florida: 8.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: 1.0,
    Illinois: 3.0,
    Indiana: 1.0,
    Iowa: null,
    Kansas: 1.0,
    Kentucky: 4.0,
    Louisiana: null,
    Maine: 1.0,
    Maryland: null,
    Massachusetts: 3.0,
    Michigan: null,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": 2.0,
    "New Mexico": 1.0,
    "New York": 6.0,
    None: 14.0,
    "North Carolina": 1.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 3.0,
    Oklahoma: null,
    Oregon: 1.0,
    Pennsylvania: 3.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 1.0,
    "South Dakota": null,
    Tennessee: 3.0,
    Texas: 9.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: null,
    Washington: 3.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  46: {
    Alabama: null,
    Alaska: null,
    Arizona: 1.0,
    Arkansas: 1.0,
    California: 15.0,
    Colorado: null,
    Connecticut: 1.0,
    "D.C.": 2.0,
    Delaware: null,
    Florida: 3.0,
    Georgia: null,
    Guam: null,
    Hawaii: 1.0,
    Idaho: 1.0,
    Illinois: 1.0,
    Indiana: 1.0,
    Iowa: null,
    Kansas: null,
    Kentucky: 2.0,
    Louisiana: 1.0,
    Maine: null,
    Maryland: null,
    Massachusetts: 3.0,
    Michigan: 2.0,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: null,
    Montana: 1.0,
    Nebraska: null,
    Nevada: 2.0,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": 1.0,
    "New York": 6.0,
    None: 12.0,
    "North Carolina": 1.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 3.0,
    Oklahoma: null,
    Oregon: 2.0,
    Pennsylvania: 3.0,
    "Puerto Rico": null,
    "Rhode Island": 1.0,
    "South Carolina": 1.0,
    "South Dakota": null,
    Tennessee: null,
    Texas: 4.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 3.0,
    Washington: 4.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  47: {
    Alabama: null,
    Alaska: null,
    Arizona: 3.0,
    Arkansas: null,
    California: 11.0,
    Colorado: 1.0,
    Connecticut: 1.0,
    "D.C.": 1.0,
    Delaware: null,
    Florida: 2.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: 3.0,
    Idaho: null,
    Illinois: 2.0,
    Indiana: null,
    Iowa: null,
    Kansas: null,
    Kentucky: null,
    Louisiana: 1.0,
    Maine: 1.0,
    Maryland: 1.0,
    Massachusetts: 1.0,
    Michigan: 2.0,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: 3.0,
    Montana: null,
    Nebraska: null,
    Nevada: 2.0,
    "New Hampshire": null,
    "New Jersey": 2.0,
    "New Mexico": null,
    "New York": 10.0,
    None: 15.0,
    "North Carolina": 3.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 3.0,
    Oklahoma: 2.0,
    Oregon: 1.0,
    Pennsylvania: 3.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 2.0,
    "South Dakota": null,
    Tennessee: 1.0,
    Texas: 2.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 1.0,
    Washington: 1.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  48: {
    Alabama: 1.0,
    Alaska: null,
    Arizona: 4.0,
    Arkansas: null,
    California: 12.0,
    Colorado: 2.0,
    Connecticut: 1.0,
    "D.C.": 4.0,
    Delaware: null,
    Florida: 6.0,
    Georgia: null,
    Guam: null,
    Hawaii: null,
    Idaho: 2.0,
    Illinois: 1.0,
    Indiana: null,
    Iowa: null,
    Kansas: 1.0,
    Kentucky: 1.0,
    Louisiana: 1.0,
    Maine: 1.0,
    Maryland: null,
    Massachusetts: 3.0,
    Michigan: 2.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: 2.0,
    Montana: 1.0,
    Nebraska: 2.0,
    Nevada: 2.0,
    "New Hampshire": null,
    "New Jersey": 2.0,
    "New Mexico": 4.0,
    "New York": 8.0,
    None: 15.0,
    "North Carolina": 2.0,
    "North Dakota": 1.0,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: 2.0,
    Oregon: 3.0,
    Pennsylvania: 1.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 1.0,
    "South Dakota": 1.0,
    Tennessee: 1.0,
    Texas: 12.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: 3.0,
    Washington: 4.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  49: {
    Alabama: null,
    Alaska: null,
    Arizona: null,
    Arkansas: null,
    California: 7.0,
    Colorado: null,
    Connecticut: 1.0,
    "D.C.": 2.0,
    Delaware: null,
    Florida: 3.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: null,
    Indiana: null,
    Iowa: null,
    Kansas: null,
    Kentucky: 1.0,
    Louisiana: 1.0,
    Maine: null,
    Maryland: 1.0,
    Massachusetts: null,
    Michigan: 1.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: null,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": 1.0,
    "New York": 2.0,
    None: 10.0,
    "North Carolina": null,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 1.0,
    Oklahoma: 2.0,
    Oregon: null,
    Pennsylvania: 2.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: 1.0,
    Texas: 2.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: null,
    Washington: null,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  50: {
    Alabama: 2.0,
    Alaska: null,
    Arizona: null,
    Arkansas: 1.0,
    California: 20.0,
    Colorado: 3.0,
    Connecticut: null,
    "D.C.": null,
    Delaware: null,
    Florida: 1.0,
    Georgia: null,
    Guam: null,
    Hawaii: 1.0,
    Idaho: null,
    Illinois: 6.0,
    Indiana: null,
    Iowa: null,
    Kansas: null,
    Kentucky: null,
    Louisiana: null,
    Maine: 1.0,
    Maryland: 2.0,
    Massachusetts: 3.0,
    Michigan: 3.0,
    Minnesota: 3.0,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": 3.0,
    "New Mexico": 1.0,
    "New York": 13.0,
    None: 14.0,
    "North Carolina": 5.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 3.0,
    Oklahoma: null,
    Oregon: 3.0,
    Pennsylvania: 1.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": 1.0,
    Tennessee: null,
    Texas: 5.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: 2.0,
    Washington: null,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  51: {
    Alabama: 1.0,
    Alaska: null,
    Arizona: 1.0,
    Arkansas: null,
    California: 18.0,
    Colorado: 2.0,
    Connecticut: null,
    "D.C.": 1.0,
    Delaware: null,
    Florida: 3.0,
    Georgia: 2.0,
    Guam: 1.0,
    Hawaii: null,
    Idaho: null,
    Illinois: 3.0,
    Indiana: 2.0,
    Iowa: null,
    Kansas: null,
    Kentucky: 1.0,
    Louisiana: null,
    Maine: null,
    Maryland: 3.0,
    Massachusetts: null,
    Michigan: 1.0,
    Minnesota: 2.0,
    Mississippi: 1.0,
    Missouri: 1.0,
    Montana: null,
    Nebraska: null,
    Nevada: 3.0,
    "New Hampshire": 1.0,
    "New Jersey": 1.0,
    "New Mexico": 1.0,
    "New York": 5.0,
    None: 22.0,
    "North Carolina": null,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 6.0,
    Oklahoma: 1.0,
    Oregon: 2.0,
    Pennsylvania: 1.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: 3.0,
    Texas: 11.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 3.0,
    Washington: 3.0,
    "West Virginia": null,
    Wisconsin: 1.0,
    Wyoming: null,
  },
  52: {
    Alabama: 2.0,
    Alaska: null,
    Arizona: 3.0,
    Arkansas: null,
    California: 10.0,
    Colorado: null,
    Connecticut: null,
    "D.C.": 1.0,
    Delaware: null,
    Florida: 1.0,
    Georgia: null,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 1.0,
    Indiana: 1.0,
    Iowa: null,
    Kansas: 1.0,
    Kentucky: null,
    Louisiana: 1.0,
    Maine: null,
    Maryland: 1.0,
    Massachusetts: 1.0,
    Michigan: 2.0,
    Minnesota: null,
    Mississippi: 1.0,
    Missouri: null,
    Montana: 1.0,
    Nebraska: null,
    Nevada: 2.0,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": null,
    "New York": 6.0,
    None: 14.0,
    "North Carolina": 1.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: null,
    Oregon: null,
    Pennsylvania: 1.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: null,
    Texas: 11.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 3.0,
    Washington: 2.0,
    "West Virginia": null,
    Wisconsin: 1.0,
    Wyoming: 1.0,
  },
  53: {
    Alabama: 1.0,
    Alaska: 1.0,
    Arizona: 2.0,
    Arkansas: null,
    California: 15.0,
    Colorado: 1.0,
    Connecticut: 1.0,
    "D.C.": null,
    Delaware: null,
    Florida: 2.0,
    Georgia: 4.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: 1.0,
    Illinois: 1.0,
    Indiana: null,
    Iowa: null,
    Kansas: null,
    Kentucky: 2.0,
    Louisiana: 2.0,
    Maine: null,
    Maryland: 5.0,
    Massachusetts: null,
    Michigan: null,
    Minnesota: null,
    Mississippi: null,
    Missouri: 2.0,
    Montana: null,
    Nebraska: null,
    Nevada: 2.0,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": 1.0,
    "New York": 4.0,
    None: 10.0,
    "North Carolina": 1.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 1.0,
    Oklahoma: null,
    Oregon: null,
    Pennsylvania: 2.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: null,
    Texas: 2.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 2.0,
    Washington: 2.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  54: {
    Alabama: null,
    Alaska: null,
    Arizona: 2.0,
    Arkansas: null,
    California: 5.0,
    Colorado: 1.0,
    Connecticut: null,
    "D.C.": 1.0,
    Delaware: null,
    Florida: 1.0,
    Georgia: null,
    Guam: null,
    Hawaii: 1.0,
    Idaho: null,
    Illinois: 2.0,
    Indiana: null,
    Iowa: null,
    Kansas: null,
    Kentucky: 1.0,
    Louisiana: 1.0,
    Maine: null,
    Maryland: null,
    Massachusetts: 2.0,
    Michigan: null,
    Minnesota: 2.0,
    Mississippi: 1.0,
    Missouri: null,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": null,
    "New York": 4.0,
    None: 8.0,
    "North Carolina": null,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: null,
    Oklahoma: null,
    Oregon: 1.0,
    Pennsylvania: 2.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: null,
    Texas: 3.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 1.0,
    Washington: null,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  55: {
    Alabama: 1.0,
    Alaska: null,
    Arizona: null,
    Arkansas: null,
    California: 26.0,
    Colorado: null,
    Connecticut: 3.0,
    "D.C.": 2.0,
    Delaware: null,
    Florida: 5.0,
    Georgia: 5.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: null,
    Illinois: 2.0,
    Indiana: 2.0,
    Iowa: null,
    Kansas: null,
    Kentucky: null,
    Louisiana: 1.0,
    Maine: 2.0,
    Maryland: null,
    Massachusetts: 1.0,
    Michigan: 1.0,
    Minnesota: 2.0,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": 4.0,
    "New Mexico": null,
    "New York": 8.0,
    None: 12.0,
    "North Carolina": 2.0,
    "North Dakota": 1.0,
    "Northern Mariana Islands": null,
    Ohio: 1.0,
    Oklahoma: null,
    Oregon: 1.0,
    Pennsylvania: 2.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: 3.0,
    Texas: 5.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 3.0,
    Washington: 4.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  56: {
    Alabama: 1.0,
    Alaska: null,
    Arizona: 2.0,
    Arkansas: 1.0,
    California: 14.0,
    Colorado: 3.0,
    Connecticut: 2.0,
    "D.C.": null,
    Delaware: null,
    Florida: 4.0,
    Georgia: 7.0,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 4.0,
    Indiana: 1.0,
    Iowa: 1.0,
    Kansas: 1.0,
    Kentucky: 1.0,
    Louisiana: 2.0,
    Maine: 1.0,
    Maryland: 1.0,
    Massachusetts: null,
    Michigan: 3.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: null,
    Montana: null,
    Nebraska: null,
    Nevada: 1.0,
    "New Hampshire": null,
    "New Jersey": 1.0,
    "New Mexico": null,
    "New York": 7.0,
    None: 19.0,
    "North Carolina": 1.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: null,
    Oregon: 4.0,
    Pennsylvania: 3.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: 1.0,
    Texas: 10.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: 1.0,
    Washington: 5.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: 1.0,
  },
  57: {
    Alabama: null,
    Alaska: null,
    Arizona: 1.0,
    Arkansas: null,
    California: 12.0,
    Colorado: 2.0,
    Connecticut: 1.0,
    "D.C.": 1.0,
    Delaware: null,
    Florida: 5.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 2.0,
    Indiana: null,
    Iowa: 1.0,
    Kansas: null,
    Kentucky: null,
    Louisiana: null,
    Maine: null,
    Maryland: null,
    Massachusetts: 1.0,
    Michigan: 1.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: null,
    Nevada: 1.0,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": null,
    "New York": 7.0,
    None: 7.0,
    "North Carolina": null,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 1.0,
    Oklahoma: null,
    Oregon: 2.0,
    Pennsylvania: 3.0,
    "Puerto Rico": 1.0,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: 1.0,
    Texas: 3.0,
    "United States Virgin Islands": null,
    Utah: 2.0,
    Vermont: null,
    Virginia: null,
    Washington: 2.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  58: {
    Alabama: null,
    Alaska: 1.0,
    Arizona: 3.0,
    Arkansas: 2.0,
    California: 14.0,
    Colorado: 1.0,
    Connecticut: null,
    "D.C.": 2.0,
    Delaware: null,
    Florida: 3.0,
    Georgia: 6.0,
    Guam: null,
    Hawaii: null,
    Idaho: 1.0,
    Illinois: 1.0,
    Indiana: 2.0,
    Iowa: null,
    Kansas: 1.0,
    Kentucky: 1.0,
    Louisiana: 1.0,
    Maine: null,
    Maryland: 1.0,
    Massachusetts: 3.0,
    Michigan: 1.0,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": null,
    "New York": 14.0,
    None: 11.0,
    "North Carolina": null,
    "North Dakota": 1.0,
    "Northern Mariana Islands": null,
    Ohio: 4.0,
    Oklahoma: null,
    Oregon: 2.0,
    Pennsylvania: 4.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 2.0,
    "South Dakota": null,
    Tennessee: 1.0,
    Texas: 9.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: null,
    Washington: null,
    "West Virginia": 1.0,
    Wisconsin: null,
    Wyoming: null,
  },
  59: {
    Alabama: null,
    Alaska: 1.0,
    Arizona: 2.0,
    Arkansas: 1.0,
    California: 17.0,
    Colorado: 1.0,
    Connecticut: null,
    "D.C.": null,
    Delaware: null,
    Florida: 3.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 3.0,
    Indiana: 1.0,
    Iowa: 1.0,
    Kansas: null,
    Kentucky: 1.0,
    Louisiana: 1.0,
    Maine: 2.0,
    Maryland: 1.0,
    Massachusetts: 2.0,
    Michigan: 1.0,
    Minnesota: 1.0,
    Mississippi: 1.0,
    Missouri: 2.0,
    Montana: 3.0,
    Nebraska: 2.0,
    Nevada: 1.0,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": null,
    "New York": 11.0,
    None: 19.0,
    "North Carolina": 6.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: 1.0,
    Oregon: 1.0,
    Pennsylvania: 2.0,
    "Puerto Rico": null,
    "Rhode Island": 1.0,
    "South Carolina": 2.0,
    "South Dakota": 1.0,
    Tennessee: 3.0,
    Texas: 8.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 5.0,
    Washington: 2.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: 1.0,
  },
  60: {
    Alabama: null,
    Alaska: null,
    Arizona: 3.0,
    Arkansas: null,
    California: 30.0,
    Colorado: 2.0,
    Connecticut: 1.0,
    "D.C.": 4.0,
    Delaware: null,
    Florida: 11.0,
    Georgia: 5.0,
    Guam: null,
    Hawaii: 2.0,
    Idaho: null,
    Illinois: 7.0,
    Indiana: 1.0,
    Iowa: null,
    Kansas: null,
    Kentucky: 1.0,
    Louisiana: null,
    Maine: 1.0,
    Maryland: 1.0,
    Massachusetts: 5.0,
    Michigan: 2.0,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: null,
    Montana: null,
    Nebraska: null,
    Nevada: 4.0,
    "New Hampshire": null,
    "New Jersey": 3.0,
    "New Mexico": null,
    "New York": 12.0,
    None: 20.0,
    "North Carolina": null,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 4.0,
    Oklahoma: 5.0,
    Oregon: 2.0,
    Pennsylvania: 3.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": 1.0,
    Tennessee: 1.0,
    Texas: 13.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: 3.0,
    Washington: 8.0,
    "West Virginia": null,
    Wisconsin: 1.0,
    Wyoming: 1.0,
  },
  61: {
    Alabama: 1.0,
    Alaska: null,
    Arizona: 1.0,
    Arkansas: null,
    California: 15.0,
    Colorado: 1.0,
    Connecticut: null,
    "D.C.": 3.0,
    Delaware: 1.0,
    Florida: 5.0,
    Georgia: 4.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: 1.0,
    Illinois: null,
    Indiana: 1.0,
    Iowa: null,
    Kansas: 1.0,
    Kentucky: null,
    Louisiana: 1.0,
    Maine: 1.0,
    Maryland: 1.0,
    Massachusetts: 3.0,
    Michigan: 3.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: 2.0,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": 2.0,
    "New Mexico": 1.0,
    "New York": 8.0,
    None: 14.0,
    "North Carolina": 1.0,
    "North Dakota": 1.0,
    "Northern Mariana Islands": null,
    Ohio: 5.0,
    Oklahoma: 2.0,
    Oregon: 1.0,
    Pennsylvania: 3.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 4.0,
    "South Dakota": null,
    Tennessee: 3.0,
    Texas: 8.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: 1.0,
    Virginia: 2.0,
    Washington: 2.0,
    "West Virginia": 1.0,
    Wisconsin: null,
    Wyoming: 1.0,
  },
  62: {
    Alabama: null,
    Alaska: null,
    Arizona: 1.0,
    Arkansas: null,
    California: 6.0,
    Colorado: 2.0,
    Connecticut: null,
    "D.C.": 1.0,
    Delaware: null,
    Florida: 7.0,
    Georgia: 5.0,
    Guam: null,
    Hawaii: null,
    Idaho: 1.0,
    Illinois: 1.0,
    Indiana: 2.0,
    Iowa: null,
    Kansas: null,
    Kentucky: 1.0,
    Louisiana: 1.0,
    Maine: null,
    Maryland: 1.0,
    Massachusetts: 2.0,
    Michigan: 1.0,
    Minnesota: 3.0,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: null,
    Nevada: 2.0,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": 1.0,
    "New York": 6.0,
    None: 12.0,
    "North Carolina": null,
    "North Dakota": 1.0,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: 2.0,
    Oregon: null,
    Pennsylvania: 1.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: null,
    Texas: 4.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: null,
    Washington: null,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  63: {
    Alabama: 1.0,
    Alaska: null,
    Arizona: 1.0,
    Arkansas: 1.0,
    California: 16.0,
    Colorado: 6.0,
    Connecticut: null,
    "D.C.": 5.0,
    Delaware: null,
    Florida: 10.0,
    Georgia: 6.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: null,
    Illinois: 1.0,
    Indiana: 1.0,
    Iowa: null,
    Kansas: null,
    Kentucky: 1.0,
    Louisiana: 2.0,
    Maine: null,
    Maryland: null,
    Massachusetts: 2.0,
    Michigan: null,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: 1.0,
    Nevada: 1.0,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": null,
    "New York": 8.0,
    None: 11.0,
    "North Carolina": 4.0,
    "North Dakota": 1.0,
    "Northern Mariana Islands": null,
    Ohio: 5.0,
    Oklahoma: 1.0,
    Oregon: 1.0,
    Pennsylvania: 1.0,
    "Puerto Rico": 1.0,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: 5.0,
    Texas: 8.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: 1.0,
    Virginia: null,
    Washington: 3.0,
    "West Virginia": 1.0,
    Wisconsin: 1.0,
    Wyoming: 1.0,
  },
  64: {
    Alabama: null,
    Alaska: 1.0,
    Arizona: 1.0,
    Arkansas: null,
    California: 22.0,
    Colorado: 1.0,
    Connecticut: null,
    "D.C.": 5.0,
    Delaware: null,
    Florida: 3.0,
    Georgia: 4.0,
    Guam: null,
    Hawaii: 2.0,
    Idaho: null,
    Illinois: 5.0,
    Indiana: 1.0,
    Iowa: null,
    Kansas: null,
    Kentucky: null,
    Louisiana: 2.0,
    Maine: null,
    Maryland: 2.0,
    Massachusetts: 3.0,
    Michigan: 3.0,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: null,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": 1.0,
    "New Mexico": null,
    "New York": 6.0,
    None: 14.0,
    "North Carolina": null,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 1.0,
    Oklahoma: 1.0,
    Oregon: 3.0,
    Pennsylvania: 5.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 1.0,
    "South Dakota": null,
    Tennessee: null,
    Texas: 10.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: 1.0,
    Virginia: 1.0,
    Washington: 2.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  65: {
    Alabama: null,
    Alaska: null,
    Arizona: 2.0,
    Arkansas: 1.0,
    California: 14.0,
    Colorado: null,
    Connecticut: 1.0,
    "D.C.": 7.0,
    Delaware: null,
    Florida: 4.0,
    Georgia: 4.0,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 3.0,
    Indiana: 1.0,
    Iowa: null,
    Kansas: null,
    Kentucky: 1.0,
    Louisiana: 1.0,
    Maine: 2.0,
    Maryland: 1.0,
    Massachusetts: 2.0,
    Michigan: null,
    Minnesota: null,
    Mississippi: null,
    Missouri: null,
    Montana: 1.0,
    Nebraska: null,
    Nevada: 4.0,
    "New Hampshire": null,
    "New Jersey": 3.0,
    "New Mexico": null,
    "New York": 2.0,
    None: 7.0,
    "North Carolina": null,
    "North Dakota": 1.0,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: null,
    Oregon: null,
    Pennsylvania: null,
    "Puerto Rico": null,
    "Rhode Island": 1.0,
    "South Carolina": 1.0,
    "South Dakota": null,
    Tennessee: 1.0,
    Texas: 7.0,
    "United States Virgin Islands": null,
    Utah: 3.0,
    Vermont: null,
    Virginia: null,
    Washington: 1.0,
    "West Virginia": null,
    Wisconsin: 1.0,
    Wyoming: null,
  },
  66: {
    Alabama: null,
    Alaska: null,
    Arizona: null,
    Arkansas: null,
    California: 4.0,
    Colorado: null,
    Connecticut: null,
    "D.C.": 2.0,
    Delaware: null,
    Florida: 4.0,
    Georgia: 4.0,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: null,
    Indiana: 2.0,
    Iowa: null,
    Kansas: null,
    Kentucky: null,
    Louisiana: null,
    Maine: null,
    Maryland: 3.0,
    Massachusetts: 3.0,
    Michigan: 2.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: null,
    Montana: null,
    Nebraska: null,
    Nevada: 1.0,
    "New Hampshire": null,
    "New Jersey": 1.0,
    "New Mexico": null,
    "New York": 6.0,
    None: 7.0,
    "North Carolina": null,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 3.0,
    Oklahoma: null,
    Oregon: 1.0,
    Pennsylvania: null,
    "Puerto Rico": 1.0,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: null,
    Texas: 5.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: null,
    Washington: null,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  67: {
    Alabama: null,
    Alaska: null,
    Arizona: 1.0,
    Arkansas: null,
    California: 9.0,
    Colorado: null,
    Connecticut: 1.0,
    "D.C.": 5.0,
    Delaware: null,
    Florida: 2.0,
    Georgia: 2.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: null,
    Illinois: 1.0,
    Indiana: 1.0,
    Iowa: 2.0,
    Kansas: null,
    Kentucky: 2.0,
    Louisiana: null,
    Maine: null,
    Maryland: null,
    Massachusetts: null,
    Michigan: 2.0,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: null,
    Montana: null,
    Nebraska: null,
    Nevada: 1.0,
    "New Hampshire": 1.0,
    "New Jersey": 2.0,
    "New Mexico": null,
    "New York": 7.0,
    None: 13.0,
    "North Carolina": 1.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: null,
    Oklahoma: null,
    Oregon: null,
    Pennsylvania: 1.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 2.0,
    "South Dakota": null,
    Tennessee: 2.0,
    Texas: 8.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 1.0,
    Washington: 3.0,
    "West Virginia": 1.0,
    Wisconsin: null,
    Wyoming: null,
  },
  68: {
    Alabama: null,
    Alaska: null,
    Arizona: null,
    Arkansas: null,
    California: 7.0,
    Colorado: null,
    Connecticut: 2.0,
    "D.C.": null,
    Delaware: null,
    Florida: 6.0,
    Georgia: 2.0,
    Guam: null,
    Hawaii: null,
    Idaho: 1.0,
    Illinois: 2.0,
    Indiana: 1.0,
    Iowa: null,
    Kansas: null,
    Kentucky: null,
    Louisiana: 1.0,
    Maine: null,
    Maryland: null,
    Massachusetts: 1.0,
    Michigan: null,
    Minnesota: 3.0,
    Mississippi: 1.0,
    Missouri: null,
    Montana: null,
    Nebraska: null,
    Nevada: 1.0,
    "New Hampshire": 1.0,
    "New Jersey": 2.0,
    "New Mexico": null,
    "New York": 10.0,
    None: 9.0,
    "North Carolina": 2.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: null,
    Oregon: null,
    Pennsylvania: null,
    "Puerto Rico": 1.0,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: null,
    Texas: 2.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 2.0,
    Washington: null,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  69: {
    Alabama: 2.0,
    Alaska: null,
    Arizona: 5.0,
    Arkansas: 1.0,
    California: 10.0,
    Colorado: 3.0,
    Connecticut: 1.0,
    "D.C.": 6.0,
    Delaware: null,
    Florida: 6.0,
    Georgia: 3.0,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 2.0,
    Indiana: 1.0,
    Iowa: 1.0,
    Kansas: null,
    Kentucky: 1.0,
    Louisiana: 1.0,
    Maine: 2.0,
    Maryland: 2.0,
    Massachusetts: 3.0,
    Michigan: 3.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: 2.0,
    Montana: null,
    Nebraska: null,
    Nevada: 1.0,
    "New Hampshire": null,
    "New Jersey": 1.0,
    "New Mexico": null,
    "New York": 8.0,
    None: 24.0,
    "North Carolina": 1.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: null,
    Oregon: 2.0,
    Pennsylvania: 6.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 2.0,
    "South Dakota": null,
    Tennessee: 2.0,
    Texas: 16.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: 1.0,
    Washington: 4.0,
    "West Virginia": null,
    Wisconsin: 2.0,
    Wyoming: 1.0,
  },
  70: {
    Alabama: null,
    Alaska: 1.0,
    Arizona: 4.0,
    Arkansas: 2.0,
    California: 21.0,
    Colorado: 1.0,
    Connecticut: null,
    "D.C.": 1.0,
    Delaware: null,
    Florida: 5.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: null,
    Illinois: 4.0,
    Indiana: 3.0,
    Iowa: null,
    Kansas: 1.0,
    Kentucky: 1.0,
    Louisiana: 1.0,
    Maine: null,
    Maryland: 1.0,
    Massachusetts: 3.0,
    Michigan: 1.0,
    Minnesota: 3.0,
    Mississippi: 1.0,
    Missouri: 1.0,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": 1.0,
    "New Jersey": 1.0,
    "New Mexico": 1.0,
    "New York": 7.0,
    None: 21.0,
    "North Carolina": 6.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 6.0,
    Oklahoma: 1.0,
    Oregon: 1.0,
    Pennsylvania: 4.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: 2.0,
    Texas: 11.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: 4.0,
    Washington: 2.0,
    "West Virginia": null,
    Wisconsin: 1.0,
    Wyoming: 2.0,
  },
  71: {
    Alabama: null,
    Alaska: null,
    Arizona: 2.0,
    Arkansas: 2.0,
    California: 10.0,
    Colorado: null,
    Connecticut: null,
    "D.C.": 2.0,
    Delaware: null,
    Florida: 9.0,
    Georgia: 2.0,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 2.0,
    Indiana: 2.0,
    Iowa: null,
    Kansas: null,
    Kentucky: 1.0,
    Louisiana: null,
    Maine: null,
    Maryland: null,
    Massachusetts: 1.0,
    Michigan: 4.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: null,
    Nevada: 1.0,
    "New Hampshire": null,
    "New Jersey": 1.0,
    "New Mexico": 3.0,
    "New York": 6.0,
    None: 6.0,
    "North Carolina": 3.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 3.0,
    Oklahoma: null,
    Oregon: 2.0,
    Pennsylvania: 2.0,
    "Puerto Rico": 1.0,
    "Rhode Island": null,
    "South Carolina": 1.0,
    "South Dakota": null,
    Tennessee: 2.0,
    Texas: 8.0,
    "United States Virgin Islands": null,
    Utah: 5.0,
    Vermont: null,
    Virginia: 4.0,
    Washington: 1.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  72: {
    Alabama: 2.0,
    Alaska: null,
    Arizona: 5.0,
    Arkansas: 2.0,
    California: 18.0,
    Colorado: 1.0,
    Connecticut: 1.0,
    "D.C.": 3.0,
    Delaware: null,
    Florida: 9.0,
    Georgia: 5.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: 1.0,
    Illinois: 4.0,
    Indiana: 3.0,
    Iowa: 2.0,
    Kansas: null,
    Kentucky: 1.0,
    Louisiana: null,
    Maine: 1.0,
    Maryland: 5.0,
    Massachusetts: 4.0,
    Michigan: 2.0,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: 3.0,
    Montana: 2.0,
    Nebraska: 1.0,
    Nevada: 3.0,
    "New Hampshire": null,
    "New Jersey": 7.0,
    "New Mexico": 1.0,
    "New York": 7.0,
    None: 19.0,
    "North Carolina": 4.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 5.0,
    Oklahoma: 1.0,
    Oregon: 2.0,
    Pennsylvania: 6.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 2.0,
    "South Dakota": null,
    Tennessee: 3.0,
    Texas: 17.0,
    "United States Virgin Islands": null,
    Utah: 3.0,
    Vermont: null,
    Virginia: 5.0,
    Washington: 6.0,
    "West Virginia": 1.0,
    Wisconsin: null,
    Wyoming: null,
  },
  73: {
    Alabama: null,
    Alaska: 1.0,
    Arizona: 5.0,
    Arkansas: 1.0,
    California: 23.0,
    Colorado: 3.0,
    Connecticut: null,
    "D.C.": 1.0,
    Delaware: 1.0,
    Florida: 8.0,
    Georgia: 4.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: null,
    Illinois: 1.0,
    Indiana: null,
    Iowa: 2.0,
    Kansas: null,
    Kentucky: 2.0,
    Louisiana: 1.0,
    Maine: null,
    Maryland: 4.0,
    Massachusetts: 3.0,
    Michigan: 2.0,
    Minnesota: 1.0,
    Mississippi: 1.0,
    Missouri: null,
    Montana: null,
    Nebraska: null,
    Nevada: 3.0,
    "New Hampshire": null,
    "New Jersey": 7.0,
    "New Mexico": 3.0,
    "New York": 18.0,
    None: 35.0,
    "North Carolina": 3.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: 2.0,
    Oregon: 4.0,
    Pennsylvania: 4.0,
    "Puerto Rico": null,
    "Rhode Island": 1.0,
    "South Carolina": 1.0,
    "South Dakota": null,
    Tennessee: 3.0,
    Texas: 18.0,
    "United States Virgin Islands": null,
    Utah: 2.0,
    Vermont: null,
    Virginia: 3.0,
    Washington: 11.0,
    "West Virginia": null,
    Wisconsin: 1.0,
    Wyoming: 1.0,
  },
  74: {
    Alabama: 1.0,
    Alaska: null,
    Arizona: 4.0,
    Arkansas: 1.0,
    California: 14.0,
    Colorado: 2.0,
    Connecticut: 1.0,
    "D.C.": 5.0,
    Delaware: null,
    Florida: 5.0,
    Georgia: 2.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: 1.0,
    Illinois: 2.0,
    Indiana: null,
    Iowa: null,
    Kansas: null,
    Kentucky: null,
    Louisiana: null,
    Maine: null,
    Maryland: 2.0,
    Massachusetts: 2.0,
    Michigan: 3.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: 1.0,
    Nevada: 1.0,
    "New Hampshire": null,
    "New Jersey": 5.0,
    "New Mexico": null,
    "New York": 6.0,
    None: 15.0,
    "North Carolina": 5.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: null,
    Oklahoma: 1.0,
    Oregon: 2.0,
    Pennsylvania: 3.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 2.0,
    "South Dakota": null,
    Tennessee: 2.0,
    Texas: 10.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: 2.0,
    Washington: 1.0,
    "West Virginia": 1.0,
    Wisconsin: null,
    Wyoming: null,
  },
  75: {
    Alabama: 1.0,
    Alaska: null,
    Arizona: null,
    Arkansas: null,
    California: 13.0,
    Colorado: 1.0,
    Connecticut: null,
    "D.C.": 4.0,
    Delaware: null,
    Florida: 8.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: null,
    Illinois: 3.0,
    Indiana: 2.0,
    Iowa: 1.0,
    Kansas: null,
    Kentucky: null,
    Louisiana: null,
    Maine: null,
    Maryland: null,
    Massachusetts: null,
    Michigan: null,
    Minnesota: null,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": 1.0,
    "New Jersey": 1.0,
    "New Mexico": null,
    "New York": 6.0,
    None: 14.0,
    "North Carolina": 1.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: null,
    Oklahoma: 2.0,
    Oregon: 1.0,
    Pennsylvania: null,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 1.0,
    "South Dakota": null,
    Tennessee: 1.0,
    Texas: 7.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 3.0,
    Washington: 2.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  76: {
    Alabama: null,
    Alaska: null,
    Arizona: 1.0,
    Arkansas: 4.0,
    California: 14.0,
    Colorado: 3.0,
    Connecticut: 1.0,
    "D.C.": 3.0,
    Delaware: null,
    Florida: 8.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 4.0,
    Indiana: 3.0,
    Iowa: 2.0,
    Kansas: 2.0,
    Kentucky: 2.0,
    Louisiana: 1.0,
    Maine: null,
    Maryland: 2.0,
    Massachusetts: null,
    Michigan: 1.0,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: null,
    Montana: 1.0,
    Nebraska: null,
    Nevada: 1.0,
    "New Hampshire": null,
    "New Jersey": 1.0,
    "New Mexico": null,
    "New York": 9.0,
    None: 13.0,
    "North Carolina": 2.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: null,
    Oregon: null,
    Pennsylvania: 2.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: null,
    Texas: 7.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: 3.0,
    Washington: 2.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  77: {
    Alabama: 7.0,
    Alaska: 3.0,
    Arizona: 10.0,
    Arkansas: 5.0,
    California: 63.0,
    Colorado: 12.0,
    Connecticut: 4.0,
    "D.C.": 3.0,
    Delaware: 1.0,
    Florida: 26.0,
    Georgia: 5.0,
    Guam: null,
    Hawaii: null,
    Idaho: 4.0,
    Illinois: 7.0,
    Indiana: 5.0,
    Iowa: 3.0,
    Kansas: 2.0,
    Kentucky: 2.0,
    Louisiana: 1.0,
    Maine: 2.0,
    Maryland: 5.0,
    Massachusetts: 8.0,
    Michigan: 14.0,
    Minnesota: 3.0,
    Mississippi: 1.0,
    Missouri: 3.0,
    Montana: null,
    Nebraska: 2.0,
    Nevada: 3.0,
    "New Hampshire": null,
    "New Jersey": 7.0,
    "New Mexico": 2.0,
    "New York": 26.0,
    None: 80.0,
    "North Carolina": 6.0,
    "North Dakota": 1.0,
    "Northern Mariana Islands": null,
    Ohio: 9.0,
    Oklahoma: 4.0,
    Oregon: 8.0,
    Pennsylvania: 12.0,
    "Puerto Rico": 2.0,
    "Rhode Island": 2.0,
    "South Carolina": 7.0,
    "South Dakota": null,
    Tennessee: 8.0,
    Texas: 48.0,
    "United States Virgin Islands": null,
    Utah: 2.0,
    Vermont: 1.0,
    Virginia: 6.0,
    Washington: 14.0,
    "West Virginia": null,
    Wisconsin: 4.0,
    Wyoming: 2.0,
  },
  78: {
    Alabama: 4.0,
    Alaska: 2.0,
    Arizona: 20.0,
    Arkansas: 2.0,
    California: 72.0,
    Colorado: 17.0,
    Connecticut: 6.0,
    "D.C.": 9.0,
    Delaware: null,
    Florida: 41.0,
    Georgia: 15.0,
    Guam: 1.0,
    Hawaii: null,
    Idaho: 5.0,
    Illinois: 7.0,
    Indiana: 10.0,
    Iowa: 6.0,
    Kansas: 3.0,
    Kentucky: 4.0,
    Louisiana: 5.0,
    Maine: 2.0,
    Maryland: 7.0,
    Massachusetts: 8.0,
    Michigan: 10.0,
    Minnesota: 6.0,
    Mississippi: 1.0,
    Missouri: 10.0,
    Montana: 3.0,
    Nebraska: null,
    Nevada: 9.0,
    "New Hampshire": 1.0,
    "New Jersey": 17.0,
    "New Mexico": 2.0,
    "New York": 54.0,
    None: 97.0,
    "North Carolina": 16.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 12.0,
    Oklahoma: 8.0,
    Oregon: 9.0,
    Pennsylvania: 19.0,
    "Puerto Rico": 1.0,
    "Rhode Island": 1.0,
    "South Carolina": 7.0,
    "South Dakota": 1.0,
    Tennessee: 10.0,
    Texas: 61.0,
    "United States Virgin Islands": null,
    Utah: 4.0,
    Vermont: 1.0,
    Virginia: 15.0,
    Washington: 15.0,
    "West Virginia": 3.0,
    Wisconsin: 6.0,
    Wyoming: 3.0,
  },
  79: {
    Alabama: 6.0,
    Alaska: 2.0,
    Arizona: 14.0,
    Arkansas: 1.0,
    California: 92.0,
    Colorado: 20.0,
    Connecticut: 4.0,
    "D.C.": 10.0,
    Delaware: null,
    Florida: 44.0,
    Georgia: 12.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: 6.0,
    Illinois: 20.0,
    Indiana: 8.0,
    Iowa: 3.0,
    Kansas: 3.0,
    Kentucky: 6.0,
    Louisiana: 4.0,
    Maine: null,
    Maryland: 6.0,
    Massachusetts: 9.0,
    Michigan: 7.0,
    Minnesota: 8.0,
    Mississippi: 6.0,
    Missouri: 13.0,
    Montana: 3.0,
    Nebraska: 4.0,
    Nevada: 7.0,
    "New Hampshire": 2.0,
    "New Jersey": 16.0,
    "New Mexico": 5.0,
    "New York": 53.0,
    None: 105.0,
    "North Carolina": 12.0,
    "North Dakota": 2.0,
    "Northern Mariana Islands": null,
    Ohio: 14.0,
    Oklahoma: 4.0,
    Oregon: 3.0,
    Pennsylvania: 12.0,
    "Puerto Rico": null,
    "Rhode Island": 4.0,
    "South Carolina": 10.0,
    "South Dakota": null,
    Tennessee: 12.0,
    Texas: 54.0,
    "United States Virgin Islands": null,
    Utah: 4.0,
    Vermont: null,
    Virginia: 9.0,
    Washington: 13.0,
    "West Virginia": 2.0,
    Wisconsin: 8.0,
    Wyoming: null,
  },
  80: {
    Alabama: 4.0,
    Alaska: 2.0,
    Arizona: 10.0,
    Arkansas: 1.0,
    California: 52.0,
    Colorado: 5.0,
    Connecticut: 2.0,
    "D.C.": 1.0,
    Delaware: null,
    Florida: 19.0,
    Georgia: 3.0,
    Guam: null,
    Hawaii: null,
    Idaho: 2.0,
    Illinois: 5.0,
    Indiana: 2.0,
    Iowa: 1.0,
    Kansas: null,
    Kentucky: 1.0,
    Louisiana: 7.0,
    Maine: 2.0,
    Maryland: 2.0,
    Massachusetts: 7.0,
    Michigan: 6.0,
    Minnesota: 3.0,
    Mississippi: 1.0,
    Missouri: 5.0,
    Montana: null,
    Nebraska: 2.0,
    Nevada: 6.0,
    "New Hampshire": 1.0,
    "New Jersey": 8.0,
    "New Mexico": null,
    "New York": 26.0,
    None: 71.0,
    "North Carolina": 9.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 15.0,
    Oklahoma: 4.0,
    Oregon: 4.0,
    Pennsylvania: 9.0,
    "Puerto Rico": 2.0,
    "Rhode Island": null,
    "South Carolina": 1.0,
    "South Dakota": 1.0,
    Tennessee: 4.0,
    Texas: 32.0,
    "United States Virgin Islands": null,
    Utah: 2.0,
    Vermont: null,
    Virginia: 6.0,
    Washington: 6.0,
    "West Virginia": null,
    Wisconsin: 2.0,
    Wyoming: 2.0,
  },
  81: {
    Alabama: 4.0,
    Alaska: 1.0,
    Arizona: 4.0,
    Arkansas: null,
    California: 24.0,
    Colorado: 4.0,
    Connecticut: 3.0,
    "D.C.": 3.0,
    Delaware: null,
    Florida: 13.0,
    Georgia: 4.0,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 6.0,
    Indiana: 3.0,
    Iowa: null,
    Kansas: 3.0,
    Kentucky: 2.0,
    Louisiana: 4.0,
    Maine: 1.0,
    Maryland: 2.0,
    Massachusetts: 5.0,
    Michigan: 8.0,
    Minnesota: 2.0,
    Mississippi: null,
    Missouri: 5.0,
    Montana: null,
    Nebraska: 1.0,
    Nevada: 5.0,
    "New Hampshire": 1.0,
    "New Jersey": 5.0,
    "New Mexico": 2.0,
    "New York": 11.0,
    None: 48.0,
    "North Carolina": 3.0,
    "North Dakota": 1.0,
    "Northern Mariana Islands": null,
    Ohio: 7.0,
    Oklahoma: 1.0,
    Oregon: 5.0,
    Pennsylvania: 4.0,
    "Puerto Rico": null,
    "Rhode Island": 2.0,
    "South Carolina": 2.0,
    "South Dakota": null,
    Tennessee: 4.0,
    Texas: 20.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: 1.0,
    Washington: 3.0,
    "West Virginia": 1.0,
    Wisconsin: 3.0,
    Wyoming: null,
  },
  82: {
    Alabama: null,
    Alaska: null,
    Arizona: 3.0,
    Arkansas: null,
    California: 29.0,
    Colorado: 2.0,
    Connecticut: 1.0,
    "D.C.": 6.0,
    Delaware: null,
    Florida: 13.0,
    Georgia: 2.0,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 2.0,
    Indiana: 2.0,
    Iowa: 1.0,
    Kansas: 2.0,
    Kentucky: 2.0,
    Louisiana: null,
    Maine: null,
    Maryland: 2.0,
    Massachusetts: 2.0,
    Michigan: 1.0,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: 1.0,
    Nevada: 2.0,
    "New Hampshire": 2.0,
    "New Jersey": 5.0,
    "New Mexico": 1.0,
    "New York": 6.0,
    None: 30.0,
    "North Carolina": 6.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 4.0,
    Oklahoma: 2.0,
    Oregon: 3.0,
    Pennsylvania: 5.0,
    "Puerto Rico": null,
    "Rhode Island": 2.0,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: 4.0,
    Texas: 21.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: 4.0,
    Washington: 1.0,
    "West Virginia": null,
    Wisconsin: 1.0,
    Wyoming: 1.0,
  },
  83: {
    Alabama: null,
    Alaska: 3.0,
    Arizona: 2.0,
    Arkansas: 1.0,
    California: 23.0,
    Colorado: 4.0,
    Connecticut: null,
    "D.C.": 3.0,
    Delaware: null,
    Florida: 7.0,
    Georgia: null,
    Guam: null,
    Hawaii: 2.0,
    Idaho: 2.0,
    Illinois: 6.0,
    Indiana: null,
    Iowa: null,
    Kansas: null,
    Kentucky: 2.0,
    Louisiana: null,
    Maine: 1.0,
    Maryland: 2.0,
    Massachusetts: 1.0,
    Michigan: 2.0,
    Minnesota: 1.0,
    Mississippi: 2.0,
    Missouri: 2.0,
    Montana: 2.0,
    Nebraska: null,
    Nevada: 4.0,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": null,
    "New York": 14.0,
    None: 33.0,
    "North Carolina": 1.0,
    "North Dakota": null,
    "Northern Mariana Islands": 1.0,
    Ohio: 9.0,
    Oklahoma: 1.0,
    Oregon: 1.0,
    Pennsylvania: 3.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 2.0,
    "South Dakota": null,
    Tennessee: 5.0,
    Texas: 20.0,
    "United States Virgin Islands": 1.0,
    Utah: 1.0,
    Vermont: null,
    Virginia: 5.0,
    Washington: 6.0,
    "West Virginia": 1.0,
    Wisconsin: 2.0,
    Wyoming: null,
  },
  84: {
    Alabama: 3.0,
    Alaska: null,
    Arizona: 1.0,
    Arkansas: 2.0,
    California: 15.0,
    Colorado: null,
    Connecticut: null,
    "D.C.": null,
    Delaware: null,
    Florida: 3.0,
    Georgia: 5.0,
    Guam: null,
    Hawaii: null,
    Idaho: 3.0,
    Illinois: 3.0,
    Indiana: 1.0,
    Iowa: null,
    Kansas: 1.0,
    Kentucky: 1.0,
    Louisiana: 1.0,
    Maine: null,
    Maryland: 3.0,
    Massachusetts: 2.0,
    Michigan: 3.0,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: null,
    Nevada: 2.0,
    "New Hampshire": null,
    "New Jersey": 1.0,
    "New Mexico": 1.0,
    "New York": 6.0,
    None: 26.0,
    "North Carolina": 3.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 5.0,
    Oklahoma: 3.0,
    Oregon: 4.0,
    Pennsylvania: 4.0,
    "Puerto Rico": 3.0,
    "Rhode Island": null,
    "South Carolina": 3.0,
    "South Dakota": null,
    Tennessee: null,
    Texas: 7.0,
    "United States Virgin Islands": null,
    Utah: 3.0,
    Vermont: null,
    Virginia: 4.0,
    Washington: 5.0,
    "West Virginia": 1.0,
    Wisconsin: null,
    Wyoming: null,
  },
  85: {
    Alabama: null,
    Alaska: null,
    Arizona: 2.0,
    Arkansas: null,
    California: 24.0,
    Colorado: 2.0,
    Connecticut: 2.0,
    "D.C.": null,
    Delaware: null,
    Florida: 7.0,
    Georgia: 2.0,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 4.0,
    Indiana: null,
    Iowa: null,
    Kansas: null,
    Kentucky: null,
    Louisiana: 1.0,
    Maine: 1.0,
    Maryland: 2.0,
    Massachusetts: 2.0,
    Michigan: 1.0,
    Minnesota: null,
    Mississippi: 1.0,
    Missouri: 1.0,
    Montana: null,
    Nebraska: null,
    Nevada: 1.0,
    "New Hampshire": null,
    "New Jersey": 2.0,
    "New Mexico": 1.0,
    "New York": 7.0,
    None: 14.0,
    "North Carolina": 6.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: null,
    Oklahoma: null,
    Oregon: 1.0,
    Pennsylvania: 1.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 1.0,
    "South Dakota": null,
    Tennessee: null,
    Texas: 7.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: null,
    Washington: 4.0,
    "West Virginia": null,
    Wisconsin: 1.0,
    Wyoming: 2.0,
  },
  86: {
    Alabama: null,
    Alaska: null,
    Arizona: 2.0,
    Arkansas: null,
    California: 24.0,
    Colorado: 2.0,
    Connecticut: null,
    "D.C.": 1.0,
    Delaware: 1.0,
    Florida: 8.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: null,
    Illinois: 2.0,
    Indiana: 3.0,
    Iowa: null,
    Kansas: 1.0,
    Kentucky: null,
    Louisiana: null,
    Maine: 2.0,
    Maryland: 2.0,
    Massachusetts: 1.0,
    Michigan: 4.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: null,
    Montana: null,
    Nebraska: null,
    Nevada: 4.0,
    "New Hampshire": 1.0,
    "New Jersey": 2.0,
    "New Mexico": null,
    "New York": 12.0,
    None: 21.0,
    "North Carolina": null,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 6.0,
    Oklahoma: 3.0,
    Oregon: null,
    Pennsylvania: 6.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 2.0,
    "South Dakota": null,
    Tennessee: 3.0,
    Texas: 16.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: 1.0,
    Virginia: 6.0,
    Washington: 7.0,
    "West Virginia": null,
    Wisconsin: 1.0,
    Wyoming: null,
  },
  87: {
    Alabama: null,
    Alaska: null,
    Arizona: 1.0,
    Arkansas: null,
    California: 18.0,
    Colorado: 1.0,
    Connecticut: null,
    "D.C.": 1.0,
    Delaware: null,
    Florida: 5.0,
    Georgia: null,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 6.0,
    Indiana: 1.0,
    Iowa: null,
    Kansas: 1.0,
    Kentucky: null,
    Louisiana: null,
    Maine: 1.0,
    Maryland: 2.0,
    Massachusetts: 2.0,
    Michigan: 2.0,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: null,
    Montana: 1.0,
    Nebraska: null,
    Nevada: 2.0,
    "New Hampshire": null,
    "New Jersey": 1.0,
    "New Mexico": null,
    "New York": 9.0,
    None: 20.0,
    "North Carolina": null,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 3.0,
    Oklahoma: null,
    Oregon: 1.0,
    Pennsylvania: 1.0,
    "Puerto Rico": null,
    "Rhode Island": 2.0,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: 1.0,
    Texas: 8.0,
    "United States Virgin Islands": null,
    Utah: 4.0,
    Vermont: null,
    Virginia: 2.0,
    Washington: 3.0,
    "West Virginia": 1.0,
    Wisconsin: 3.0,
    Wyoming: 1.0,
  },
  88: {
    Alabama: null,
    Alaska: null,
    Arizona: 1.0,
    Arkansas: null,
    California: 13.0,
    Colorado: null,
    Connecticut: 2.0,
    "D.C.": 3.0,
    Delaware: 1.0,
    Florida: 4.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: null,
    Illinois: 6.0,
    Indiana: null,
    Iowa: null,
    Kansas: null,
    Kentucky: null,
    Louisiana: 1.0,
    Maine: 1.0,
    Maryland: 1.0,
    Massachusetts: 1.0,
    Michigan: 2.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: null,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": null,
    "New York": 6.0,
    None: 18.0,
    "North Carolina": 3.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 3.0,
    Oklahoma: 4.0,
    Oregon: 2.0,
    Pennsylvania: 1.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: 3.0,
    Texas: 9.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: null,
    Washington: 2.0,
    "West Virginia": 1.0,
    Wisconsin: 1.0,
    Wyoming: null,
  },
  89: {
    Alabama: 2.0,
    Alaska: null,
    Arizona: 3.0,
    Arkansas: 1.0,
    California: 15.0,
    Colorado: 1.0,
    Connecticut: 1.0,
    "D.C.": 1.0,
    Delaware: null,
    Florida: 12.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: 1.0,
    Illinois: 1.0,
    Indiana: 1.0,
    Iowa: 1.0,
    Kansas: null,
    Kentucky: null,
    Louisiana: null,
    Maine: null,
    Maryland: 3.0,
    Massachusetts: 2.0,
    Michigan: 4.0,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: null,
    Montana: null,
    Nebraska: 1.0,
    Nevada: 3.0,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": null,
    "New York": 6.0,
    None: 22.0,
    "North Carolina": 2.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: null,
    Oregon: 1.0,
    Pennsylvania: 1.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 2.0,
    "South Dakota": null,
    Tennessee: 1.0,
    Texas: 8.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: 1.0,
    Virginia: 2.0,
    Washington: null,
    "West Virginia": 1.0,
    Wisconsin: 1.0,
    Wyoming: null,
  },
  90: {
    Alabama: 1.0,
    Alaska: null,
    Arizona: 3.0,
    Arkansas: null,
    California: 27.0,
    Colorado: null,
    Connecticut: 2.0,
    "D.C.": 6.0,
    Delaware: 1.0,
    Florida: 7.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: 2.0,
    Illinois: null,
    Indiana: 3.0,
    Iowa: null,
    Kansas: null,
    Kentucky: 1.0,
    Louisiana: null,
    Maine: 3.0,
    Maryland: 1.0,
    Massachusetts: 3.0,
    Michigan: null,
    Minnesota: null,
    Mississippi: 1.0,
    Missouri: 3.0,
    Montana: 1.0,
    Nebraska: null,
    Nevada: 2.0,
    "New Hampshire": null,
    "New Jersey": 1.0,
    "New Mexico": null,
    "New York": 12.0,
    None: 32.0,
    "North Carolina": 2.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 3.0,
    Oklahoma: 4.0,
    Oregon: 3.0,
    Pennsylvania: 1.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 3.0,
    "South Dakota": null,
    Tennessee: 1.0,
    Texas: 29.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 3.0,
    Washington: 4.0,
    "West Virginia": 1.0,
    Wisconsin: 1.0,
    Wyoming: null,
  },
  91: {
    Alabama: 1.0,
    Alaska: null,
    Arizona: 3.0,
    Arkansas: null,
    California: 26.0,
    Colorado: 3.0,
    Connecticut: null,
    "D.C.": 1.0,
    Delaware: null,
    Florida: 12.0,
    Georgia: null,
    Guam: null,
    Hawaii: 1.0,
    Idaho: 1.0,
    Illinois: 3.0,
    Indiana: 1.0,
    Iowa: 2.0,
    Kansas: 1.0,
    Kentucky: 2.0,
    Louisiana: 1.0,
    Maine: null,
    Maryland: 3.0,
    Massachusetts: 2.0,
    Michigan: 4.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: null,
    Nevada: 4.0,
    "New Hampshire": null,
    "New Jersey": 3.0,
    "New Mexico": null,
    "New York": 14.0,
    None: 24.0,
    "North Carolina": null,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 3.0,
    Oklahoma: null,
    Oregon: null,
    Pennsylvania: 8.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 1.0,
    "South Dakota": null,
    Tennessee: 1.0,
    Texas: 19.0,
    "United States Virgin Islands": null,
    Utah: 2.0,
    Vermont: null,
    Virginia: 4.0,
    Washington: 6.0,
    "West Virginia": null,
    Wisconsin: 2.0,
    Wyoming: 1.0,
  },
  92: {
    Alabama: 4.0,
    Alaska: 1.0,
    Arizona: 5.0,
    Arkansas: 1.0,
    California: 31.0,
    Colorado: 6.0,
    Connecticut: 2.0,
    "D.C.": 3.0,
    Delaware: 1.0,
    Florida: 13.0,
    Georgia: 6.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: 4.0,
    Illinois: 2.0,
    Indiana: 2.0,
    Iowa: 1.0,
    Kansas: 1.0,
    Kentucky: 3.0,
    Louisiana: null,
    Maine: 1.0,
    Maryland: 5.0,
    Massachusetts: 5.0,
    Michigan: 1.0,
    Minnesota: 2.0,
    Mississippi: null,
    Missouri: 1.0,
    Montana: 1.0,
    Nebraska: null,
    Nevada: 1.0,
    "New Hampshire": null,
    "New Jersey": 2.0,
    "New Mexico": null,
    "New York": 23.0,
    None: 55.0,
    "North Carolina": 4.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 5.0,
    Oklahoma: null,
    Oregon: 1.0,
    Pennsylvania: 6.0,
    "Puerto Rico": null,
    "Rhode Island": 1.0,
    "South Carolina": 2.0,
    "South Dakota": null,
    Tennessee: 1.0,
    Texas: 25.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: 2.0,
    Washington: 7.0,
    "West Virginia": 1.0,
    Wisconsin: 1.0,
    Wyoming: 2.0,
  },
  93: {
    Alabama: null,
    Alaska: null,
    Arizona: null,
    Arkansas: 2.0,
    California: 22.0,
    Colorado: 2.0,
    Connecticut: null,
    "D.C.": 8.0,
    Delaware: null,
    Florida: 12.0,
    Georgia: 5.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: null,
    Illinois: 6.0,
    Indiana: 2.0,
    Iowa: null,
    Kansas: null,
    Kentucky: 1.0,
    Louisiana: null,
    Maine: null,
    Maryland: 6.0,
    Massachusetts: 1.0,
    Michigan: 5.0,
    Minnesota: 2.0,
    Mississippi: null,
    Missouri: 3.0,
    Montana: null,
    Nebraska: 1.0,
    Nevada: 1.0,
    "New Hampshire": null,
    "New Jersey": 4.0,
    "New Mexico": null,
    "New York": 10.0,
    None: 50.0,
    "North Carolina": 3.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 4.0,
    Oklahoma: 2.0,
    Oregon: 3.0,
    Pennsylvania: 6.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 4.0,
    "South Dakota": null,
    Tennessee: 8.0,
    Texas: 16.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: 1.0,
    Washington: 2.0,
    "West Virginia": null,
    Wisconsin: 3.0,
    Wyoming: null,
  },
  94: {
    Alabama: null,
    Alaska: null,
    Arizona: 3.0,
    Arkansas: null,
    California: 20.0,
    Colorado: 4.0,
    Connecticut: 3.0,
    "D.C.": 2.0,
    Delaware: null,
    Florida: 14.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: 1.0,
    Illinois: null,
    Indiana: 3.0,
    Iowa: null,
    Kansas: null,
    Kentucky: null,
    Louisiana: null,
    Maine: null,
    Maryland: 2.0,
    Massachusetts: 2.0,
    Michigan: 2.0,
    Minnesota: null,
    Mississippi: 1.0,
    Missouri: 1.0,
    Montana: null,
    Nebraska: null,
    Nevada: null,
    "New Hampshire": 2.0,
    "New Jersey": 5.0,
    "New Mexico": null,
    "New York": 11.0,
    None: 16.0,
    "North Carolina": 2.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 5.0,
    Oklahoma: 1.0,
    Oregon: 1.0,
    Pennsylvania: 4.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 3.0,
    "South Dakota": 1.0,
    Tennessee: 3.0,
    Texas: 21.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 4.0,
    Washington: 1.0,
    "West Virginia": null,
    Wisconsin: 2.0,
    Wyoming: null,
  },
  95: {
    Alabama: 3.0,
    Alaska: null,
    Arizona: 8.0,
    Arkansas: null,
    California: 18.0,
    Colorado: 3.0,
    Connecticut: 1.0,
    "D.C.": 3.0,
    Delaware: null,
    Florida: 9.0,
    Georgia: 2.0,
    Guam: null,
    Hawaii: null,
    Idaho: 1.0,
    Illinois: 2.0,
    Indiana: null,
    Iowa: null,
    Kansas: 1.0,
    Kentucky: 1.0,
    Louisiana: null,
    Maine: null,
    Maryland: 3.0,
    Massachusetts: 3.0,
    Michigan: 2.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: 2.0,
    Montana: null,
    Nebraska: null,
    Nevada: 4.0,
    "New Hampshire": 3.0,
    "New Jersey": 5.0,
    "New Mexico": 2.0,
    "New York": 13.0,
    None: 32.0,
    "North Carolina": 3.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: null,
    Oregon: 1.0,
    Pennsylvania: 4.0,
    "Puerto Rico": 1.0,
    "Rhode Island": null,
    "South Carolina": 3.0,
    "South Dakota": null,
    Tennessee: 2.0,
    Texas: 23.0,
    "United States Virgin Islands": null,
    Utah: 2.0,
    Vermont: null,
    Virginia: 2.0,
    Washington: 8.0,
    "West Virginia": 2.0,
    Wisconsin: null,
    Wyoming: null,
  },
  96: {
    Alabama: 2.0,
    Alaska: 1.0,
    Arizona: 3.0,
    Arkansas: null,
    California: 20.0,
    Colorado: 6.0,
    Connecticut: null,
    "D.C.": 5.0,
    Delaware: null,
    Florida: 7.0,
    Georgia: 2.0,
    Guam: null,
    Hawaii: null,
    Idaho: 1.0,
    Illinois: 4.0,
    Indiana: 2.0,
    Iowa: 1.0,
    Kansas: null,
    Kentucky: 1.0,
    Louisiana: null,
    Maine: null,
    Maryland: null,
    Massachusetts: 1.0,
    Michigan: 2.0,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: null,
    Montana: null,
    Nebraska: 1.0,
    Nevada: 1.0,
    "New Hampshire": 1.0,
    "New Jersey": 5.0,
    "New Mexico": null,
    "New York": 9.0,
    None: 28.0,
    "North Carolina": 2.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 4.0,
    Oklahoma: 1.0,
    Oregon: 1.0,
    Pennsylvania: 1.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 2.0,
    "South Dakota": null,
    Tennessee: 1.0,
    Texas: 16.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: 6.0,
    Washington: 4.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  97: {
    Alabama: 1.0,
    Alaska: 1.0,
    Arizona: 6.0,
    Arkansas: null,
    California: 16.0,
    Colorado: null,
    Connecticut: null,
    "D.C.": null,
    Delaware: null,
    Florida: 9.0,
    Georgia: 4.0,
    Guam: null,
    Hawaii: null,
    Idaho: 2.0,
    Illinois: 3.0,
    Indiana: null,
    Iowa: 1.0,
    Kansas: 1.0,
    Kentucky: 3.0,
    Louisiana: 1.0,
    Maine: null,
    Maryland: null,
    Massachusetts: 2.0,
    Michigan: 1.0,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: 2.0,
    Montana: 1.0,
    Nebraska: 1.0,
    Nevada: 1.0,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": null,
    "New York": 15.0,
    None: 22.0,
    "North Carolina": 1.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: 4.0,
    Oregon: 2.0,
    Pennsylvania: 6.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 2.0,
    "South Dakota": null,
    Tennessee: null,
    Texas: 12.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: 4.0,
    Washington: 2.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  98: {
    Alabama: null,
    Alaska: null,
    Arizona: 3.0,
    Arkansas: null,
    California: 15.0,
    Colorado: 3.0,
    Connecticut: null,
    "D.C.": 1.0,
    Delaware: null,
    Florida: 10.0,
    Georgia: 2.0,
    Guam: null,
    Hawaii: null,
    Idaho: 1.0,
    Illinois: 1.0,
    Indiana: 1.0,
    Iowa: null,
    Kansas: null,
    Kentucky: 1.0,
    Louisiana: 1.0,
    Maine: 1.0,
    Maryland: null,
    Massachusetts: 1.0,
    Michigan: 2.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: 3.0,
    Montana: null,
    Nebraska: null,
    Nevada: 4.0,
    "New Hampshire": null,
    "New Jersey": 1.0,
    "New Mexico": 2.0,
    "New York": 21.0,
    None: 27.0,
    "North Carolina": 3.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 3.0,
    Oklahoma: 1.0,
    Oregon: null,
    Pennsylvania: 3.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: 2.0,
    Texas: 15.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 3.0,
    Washington: 5.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  99: {
    Alabama: null,
    Alaska: 1.0,
    Arizona: 7.0,
    Arkansas: null,
    California: 22.0,
    Colorado: null,
    Connecticut: null,
    "D.C.": 2.0,
    Delaware: 1.0,
    Florida: 8.0,
    Georgia: 6.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: 1.0,
    Illinois: 1.0,
    Indiana: 2.0,
    Iowa: null,
    Kansas: 2.0,
    Kentucky: 1.0,
    Louisiana: 1.0,
    Maine: 1.0,
    Maryland: 2.0,
    Massachusetts: 5.0,
    Michigan: 3.0,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: 2.0,
    Montana: null,
    Nebraska: null,
    Nevada: 4.0,
    "New Hampshire": 1.0,
    "New Jersey": 4.0,
    "New Mexico": null,
    "New York": 7.0,
    None: 34.0,
    "North Carolina": 2.0,
    "North Dakota": 1.0,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: 1.0,
    Oregon: 2.0,
    Pennsylvania: 4.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 1.0,
    "South Dakota": 2.0,
    Tennessee: 3.0,
    Texas: 9.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 5.0,
    Washington: 3.0,
    "West Virginia": 2.0,
    Wisconsin: null,
    Wyoming: null,
  },
  100: {
    Alabama: 3.0,
    Alaska: null,
    Arizona: null,
    Arkansas: null,
    California: 12.0,
    Colorado: 1.0,
    Connecticut: 1.0,
    "D.C.": 2.0,
    Delaware: null,
    Florida: 8.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: null,
    Illinois: 1.0,
    Indiana: null,
    Iowa: null,
    Kansas: null,
    Kentucky: null,
    Louisiana: 1.0,
    Maine: null,
    Maryland: 2.0,
    Massachusetts: null,
    Michigan: 3.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: 6.0,
    Nevada: null,
    "New Hampshire": null,
    "New Jersey": 2.0,
    "New Mexico": 1.0,
    "New York": 9.0,
    None: 27.0,
    "North Carolina": 2.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 1.0,
    Oklahoma: 1.0,
    Oregon: 1.0,
    Pennsylvania: null,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: 1.0,
    Texas: 16.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 3.0,
    Washington: null,
    "West Virginia": 1.0,
    Wisconsin: null,
    Wyoming: 1.0,
  },
  101: {
    Alabama: null,
    Alaska: null,
    Arizona: 5.0,
    Arkansas: null,
    California: 6.0,
    Colorado: 1.0,
    Connecticut: 1.0,
    "D.C.": 1.0,
    Delaware: null,
    Florida: 4.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 1.0,
    Indiana: 2.0,
    Iowa: null,
    Kansas: null,
    Kentucky: 1.0,
    Louisiana: 1.0,
    Maine: null,
    Maryland: 1.0,
    Massachusetts: null,
    Michigan: null,
    Minnesota: null,
    Mississippi: 1.0,
    Missouri: 1.0,
    Montana: null,
    Nebraska: null,
    Nevada: 2.0,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": null,
    "New York": 6.0,
    None: 8.0,
    "North Carolina": 1.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 1.0,
    Oklahoma: null,
    Oregon: 1.0,
    Pennsylvania: 1.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: 3.0,
    Texas: 4.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: 1.0,
    Washington: 2.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: 1.0,
  },
  102: {
    Alabama: null,
    Alaska: null,
    Arizona: 7.0,
    Arkansas: 2.0,
    California: 23.0,
    Colorado: 5.0,
    Connecticut: 1.0,
    "D.C.": null,
    Delaware: null,
    Florida: 11.0,
    Georgia: 4.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: null,
    Illinois: 3.0,
    Indiana: 1.0,
    Iowa: 1.0,
    Kansas: 1.0,
    Kentucky: 2.0,
    Louisiana: 1.0,
    Maine: null,
    Maryland: 1.0,
    Massachusetts: null,
    Michigan: 4.0,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: 2.0,
    Nevada: null,
    "New Hampshire": 1.0,
    "New Jersey": 3.0,
    "New Mexico": 1.0,
    "New York": 9.0,
    None: 20.0,
    "North Carolina": 1.0,
    "North Dakota": 1.0,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: 1.0,
    Oregon: 2.0,
    Pennsylvania: 1.0,
    "Puerto Rico": 1.0,
    "Rhode Island": 1.0,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: null,
    Texas: 21.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: 1.0,
    Virginia: 2.0,
    Washington: 4.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: null,
  },
  103: {
    Alabama: 1.0,
    Alaska: null,
    Arizona: 2.0,
    Arkansas: null,
    California: 16.0,
    Colorado: 2.0,
    Connecticut: null,
    "D.C.": null,
    Delaware: 1.0,
    Florida: 7.0,
    Georgia: 1.0,
    Guam: null,
    Hawaii: null,
    Idaho: null,
    Illinois: 1.0,
    Indiana: 1.0,
    Iowa: 1.0,
    Kansas: 1.0,
    Kentucky: null,
    Louisiana: 2.0,
    Maine: null,
    Maryland: 2.0,
    Massachusetts: 3.0,
    Michigan: 2.0,
    Minnesota: 1.0,
    Mississippi: null,
    Missouri: 1.0,
    Montana: null,
    Nebraska: null,
    Nevada: 4.0,
    "New Hampshire": null,
    "New Jersey": 5.0,
    "New Mexico": null,
    "New York": 14.0,
    None: 26.0,
    "North Carolina": 2.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 4.0,
    Oklahoma: null,
    Oregon: null,
    Pennsylvania: 1.0,
    "Puerto Rico": 1.0,
    "Rhode Island": null,
    "South Carolina": 2.0,
    "South Dakota": null,
    Tennessee: 2.0,
    Texas: 14.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: 1.0,
    Washington: 3.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: 2.0,
  },
  104: {
    Alabama: null,
    Alaska: null,
    Arizona: 3.0,
    Arkansas: null,
    California: 14.0,
    Colorado: 1.0,
    Connecticut: null,
    "D.C.": 2.0,
    Delaware: null,
    Florida: 2.0,
    Georgia: 8.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: null,
    Illinois: 2.0,
    Indiana: 1.0,
    Iowa: 2.0,
    Kansas: 1.0,
    Kentucky: 1.0,
    Louisiana: null,
    Maine: null,
    Maryland: 1.0,
    Massachusetts: 4.0,
    Michigan: 3.0,
    Minnesota: 2.0,
    Mississippi: 1.0,
    Missouri: 2.0,
    Montana: null,
    Nebraska: null,
    Nevada: 2.0,
    "New Hampshire": null,
    "New Jersey": null,
    "New Mexico": null,
    "New York": 9.0,
    None: 13.0,
    "North Carolina": 3.0,
    "North Dakota": null,
    "Northern Mariana Islands": null,
    Ohio: 5.0,
    Oklahoma: 1.0,
    Oregon: 3.0,
    Pennsylvania: 4.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": 2.0,
    "South Dakota": null,
    Tennessee: null,
    Texas: 11.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: 1.0,
    Virginia: null,
    Washington: 1.0,
    "West Virginia": null,
    Wisconsin: 2.0,
    Wyoming: null,
  },
  105: {
    Alabama: null,
    Alaska: null,
    Arizona: 5.0,
    Arkansas: null,
    California: 22.0,
    Colorado: 1.0,
    Connecticut: null,
    "D.C.": 1.0,
    Delaware: 1.0,
    Florida: 8.0,
    Georgia: 2.0,
    Guam: null,
    Hawaii: 2.0,
    Idaho: null,
    Illinois: 2.0,
    Indiana: 2.0,
    Iowa: null,
    Kansas: 1.0,
    Kentucky: 2.0,
    Louisiana: null,
    Maine: null,
    Maryland: 2.0,
    Massachusetts: 1.0,
    Michigan: 3.0,
    Minnesota: null,
    Mississippi: null,
    Missouri: null,
    Montana: null,
    Nebraska: 1.0,
    Nevada: 2.0,
    "New Hampshire": null,
    "New Jersey": 3.0,
    "New Mexico": null,
    "New York": 17.0,
    None: 20.0,
    "North Carolina": 2.0,
    "North Dakota": 1.0,
    "Northern Mariana Islands": null,
    Ohio: 2.0,
    Oklahoma: null,
    Oregon: null,
    Pennsylvania: 3.0,
    "Puerto Rico": null,
    "Rhode Island": 3.0,
    "South Carolina": 1.0,
    "South Dakota": null,
    Tennessee: 1.0,
    Texas: 16.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 2.0,
    Washington: 5.0,
    "West Virginia": null,
    Wisconsin: 1.0,
    Wyoming: null,
  },
  106: {
    Alabama: 3.0,
    Alaska: null,
    Arizona: 4.0,
    Arkansas: 2.0,
    California: 17.0,
    Colorado: 2.0,
    Connecticut: null,
    "D.C.": 4.0,
    Delaware: null,
    Florida: 13.0,
    Georgia: 7.0,
    Guam: null,
    Hawaii: 1.0,
    Idaho: null,
    Illinois: 2.0,
    Indiana: 2.0,
    Iowa: null,
    Kansas: null,
    Kentucky: 3.0,
    Louisiana: null,
    Maine: null,
    Maryland: 1.0,
    Massachusetts: 2.0,
    Michigan: 7.0,
    Minnesota: 3.0,
    Mississippi: null,
    Missouri: 4.0,
    Montana: null,
    Nebraska: 2.0,
    Nevada: 1.0,
    "New Hampshire": 1.0,
    "New Jersey": 4.0,
    "New Mexico": 2.0,
    "New York": 19.0,
    None: 23.0,
    "North Carolina": 3.0,
    "North Dakota": 3.0,
    "Northern Mariana Islands": null,
    Ohio: 1.0,
    Oklahoma: 2.0,
    Oregon: 4.0,
    Pennsylvania: 4.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": 1.0,
    Tennessee: 1.0,
    Texas: 15.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: null,
    Virginia: 1.0,
    Washington: 1.0,
    "West Virginia": 1.0,
    Wisconsin: 1.0,
    Wyoming: 1.0,
  },
  107: {
    Alabama: 1.0,
    Alaska: 2.0,
    Arizona: 3.0,
    Arkansas: null,
    California: 23.0,
    Colorado: 3.0,
    Connecticut: 2.0,
    "D.C.": 7.0,
    Delaware: 1.0,
    Florida: 11.0,
    Georgia: 5.0,
    Guam: null,
    Hawaii: null,
    Idaho: 2.0,
    Illinois: 4.0,
    Indiana: 1.0,
    Iowa: null,
    Kansas: 1.0,
    Kentucky: 2.0,
    Louisiana: 1.0,
    Maine: null,
    Maryland: 3.0,
    Massachusetts: 2.0,
    Michigan: 2.0,
    Minnesota: null,
    Mississippi: 2.0,
    Missouri: 2.0,
    Montana: null,
    Nebraska: 1.0,
    Nevada: 4.0,
    "New Hampshire": null,
    "New Jersey": 2.0,
    "New Mexico": 1.0,
    "New York": 11.0,
    None: 27.0,
    "North Carolina": 3.0,
    "North Dakota": null,
    "Northern Mariana Islands": 1.0,
    Ohio: 7.0,
    Oklahoma: null,
    Oregon: 1.0,
    Pennsylvania: 6.0,
    "Puerto Rico": null,
    "Rhode Island": null,
    "South Carolina": null,
    "South Dakota": null,
    Tennessee: 3.0,
    Texas: 23.0,
    "United States Virgin Islands": null,
    Utah: null,
    Vermont: 1.0,
    Virginia: 2.0,
    Washington: 3.0,
    "West Virginia": null,
    Wisconsin: 1.0,
    Wyoming: null,
  },
  108: {
    Alabama: 3.0,
    Alaska: 1.0,
    Arizona: 9.0,
    Arkansas: 1.0,
    California: 36.0,
    Colorado: 7.0,
    Connecticut: 2.0,
    "D.C.": 2.0,
    Delaware: null,
    Florida: 19.0,
    Georgia: 3.0,
    Guam: 1.0,
    Hawaii: 1.0,
    Idaho: 1.0,
    Illinois: 9.0,
    Indiana: 3.0,
    Iowa: 3.0,
    Kansas: null,
    Kentucky: 2.0,
    Louisiana: 1.0,
    Maine: 1.0,
    Maryland: 6.0,
    Massachusetts: 7.0,
    Michigan: 5.0,
    Minnesota: 2.0,
    Mississippi: null,
    Missouri: 1.0,
    Montana: 3.0,
    Nebraska: null,
    Nevada: 1.0,
    "New Hampshire": 5.0,
    "New Jersey": null,
    "New Mexico": null,
    "New York": 11.0,
    None: 33.0,
    "North Carolina": 3.0,
    "North Dakota": 2.0,
    "Northern Mariana Islands": null,
    Ohio: 6.0,
    Oklahoma: 3.0,
    Oregon: 3.0,
    Pennsylvania: 11.0,
    "Puerto Rico": 1.0,
    "Rhode Island": 1.0,
    "South Carolina": 3.0,
    "South Dakota": 2.0,
    Tennessee: 3.0,
    Texas: 30.0,
    "United States Virgin Islands": null,
    Utah: 1.0,
    Vermont: null,
    Virginia: 3.0,
    Washington: 7.0,
    "West Virginia": null,
    Wisconsin: null,
    Wyoming: 2.0,
  },
};
